import { Component, OnDestroy, OnInit, Renderer2, ViewChild, HostListener, AfterViewInit, ElementRef } from '@angular/core';
import { Router } from '@angular/router';
import { DomSanitizer } from '@angular/platform-browser';
import { debounceTime, distinctUntilChanged, retry, Subject, take, takeUntil, timer } from 'rxjs';
import { LayoutService } from "./service/app.layout.service";
import { BenefitcalculatorService } from '../service/benefitcalculator.service';
import { Product, ProductChildDetail, ProductDetail, ProductDetails } from '../models/product';
import { AMBestRating, ConfiMultiplier, Groups, illustrationtblResponse, RiderFee, StateData, StrategyFee, SurrenderYear } from '../models/filter';
import { FormBuilder, FormControl, Validators } from '@angular/forms';
import { MenuItem, MessageService } from 'primeng/api';
import { GridData } from '../models/customer';
import { DatePipe } from '@angular/common';
import html2canvas from 'html2canvas';
import { jsPDF } from "jspdf";
import { Paginator } from 'primeng/paginator';
import { ScrollService } from '../service/scroll.service';
import { environment } from 'src/environments/environment';
import { HttpClient } from '@angular/common/http';
import { BonusType, BonusTypeId } from '../models/product.constant';
import { ExportService } from '../service/export.service';
import { UtilityFunctionService } from '../service/utility-function.service';
import { PdfService } from '../service/pdf.service';
import { ProductRider } from '../models/benefit-calculator.model';

declare var $: any;

enum StateOption {
    Contribution = "contribution",
    Income = "income"
}
enum MonthAnuallyOption {
    Monthly = 0,
    Annually = 1
}
enum sortByData {
    WithdrawalAmount = "Withdrawal Amount",
    CompanyName = "Company Name",
    ProductName = "Product Name"
}
enum allOptions {
    select1 = 'Slect1',
    select2 = 'Slect1',
    select3 = 'Slect1'
}
enum varData {
    All = "All",
    Level = "Level",
    Increasing = "Increasing",
    InflationBased = "Inflation Based",
    MaxIncome = "Max Income Option"
}

@Component({
    selector: 'app-layout',
    templateUrl: './app.layout.component.html',
    styleUrls: ['./app.layout.component.scss']
    // providers: [MessageService]
})
export class AppLayoutComponent implements OnDestroy, OnInit, AfterViewInit {

    @ViewChild('exportPdf') exportPdf!: ElementRef;
    @ViewChild('searchResult') searchResult!: ElementRef;
    @ViewChild('resultCounter') resultCounter!: ElementRef;
    @ViewChild('cardCompare') cardCompare!: ElementRef;

    private destroy$ = new Subject<void>();

    filterEdit: any;
    savedtype: string = '';
    IsCustomShelf: boolean = false;
    // CustomShelflist: any[] = [];
    createShelfPopup: boolean = false;
    incomeTypes = varData;

    //topbar form
    topbarForm = this.fb.group({
        gender: ['',],
        age: [0, Validators.required],
        acalendar: ['', Validators.required],
        maritalstatus: ['joint', Validators.required],
        pouseage: [0],
        scalendar: [''],
        illinois: [''],
        ridertype: [''],
        Contribution: [''],
        income: [''],
        amount: [100000, Validators.required],
        periode: [true],
        diffperiode: [10],
    })

    searchDataForm = this.fb.group({
        searchtitle: ['', [Validators.required, this.noWhitespaceValidator]]
    })
    saveFormSubmitted: boolean = false;

    //Product Profile
    userlogo: any;
    username: any;
    productProfileDetails: any = {};
    productProfileData: any[] = [];
    selectedStateName: any;

    stateCode: string = '';
    productId: number = 0;
    properity: string = '';

    companyLogo1: any;
    companyLogo2: any;
    premiumType: string = '';
    preBonuse: string = '';
    vestingBonuse: string = '';
    credStrategies: any[] = [];
    indexesAvailable: any;
    indexes: any;
    index: any[] = [];
    tiker: any[] = [];
    pspouseAge: Number = 0;

    //Product Profile
    agecheck: number = 0;
    spouseagecheck: number = 0;
    amountcheck: number = 0;
    diffperiodecheck: number = 0;

    //topbar vars 
    incCont: string = 'contribution';
    periodeam: number = 1;
    requestValues: any = {};
    filteredArray: any = [];
    ispagination: boolean = false;
    first: number = 0;
    notFount: boolean = false
    stateCodeFilter: any;
    genderDataList: any[];
    diffperiode: number = 10;


    //sidebar vars start
    sideMenuShow: boolean = false;
    selectedtab: string = 'Sidebar';
    model: any[] = [];
    selectedStrategyFee: any;
    selectedRiderFee: any;
    selectedGroups: string[] = [];
    selectedSuryear: any[] = [];
    selectedAMBestrating: string[] = [];
    selectedSortBy: any = 'Withdrawal Amount';
    selectedSortBymodel: any = 'Withdrawal Amount';
    categories: any[] = [];
    product: ProductDetails[] = [];
    productList: any;
    amBestRating: AMBestRating[] = [];
    riderFee: RiderFee[] = [];
    surrenderYear: SurrenderYear[] = [];
    strategyFee: StrategyFee[] = [];
    strategyFeeOptions: any[] = [];
    benifitBaseType: any[] = [];
    groups: Groups[] = [];
    confiMultiplier: ConfiMultiplier[] = [];
    stateData: StateData[] = [];
    varData: any[] = [];
    illustrationtblResponse: illustrationtblResponse[] = [];
    illustrationResData: any = {};
    ProductDetail: ProductDetail[] = [];
    ProductChildDetail: ProductChildDetail[] | undefined;
    //sidebar vars end

    //deshboard vars start
    checked: boolean = false;
    showmodel = false;
    useritems!: MenuItem[];
    items!: MenuItem[];
    itemslist!: MenuItem[];
    products!: Product[];
    gridData: GridData[] = [];
    allProducts: any[] = [];
    filterCustomself: any[] = [];
    customProductList: any[] = [];
    custoShelfShow: boolean = false;

    //Flags
    isLoader: boolean = false;
    isSubmit: boolean = false;
    isLoad: boolean = false;
    isCompare: boolean = false;
    isSwitch: boolean = false;
    comparedataItem: any;
    compEvent: any;
    compDataChk: boolean = true;
    totalMatches: number = 0;
    IncomePeriod: any;

    // models for bind chips
    SelectFilter: any[] = [];
    SelectFilter_AMbest: any[] = [];
    SelectFilter_AMbest_name: any[] = [];
    selectedProducts: any[] = [];
    SelectFilter6: any[] = [];

    //short by props
    compareData: any[] = [];
    totalCompare: number = 0;

    //models
    riderFeeData: any[] = [];
    filterdataobj_group: any[] = []
    filterdataobj_group_name: any[] = []
    filterdataobj_surrender_year: any[] = []
    filterdataobj_surrender_year_name: any[] = []
    filterdataobj_products: any[] = []
    filterdataobj_products_name: any[] = [];
    filterdataobj_riderfee: any[] = []
    filterdataobj_riderfee_name: any[] = []
    filterdataobj_strategyfee: any[] = []
    filterdataobj_strategyfee_name: any[] = []
    filterdataobj_short: any[] = []
    filterdataobj_confiMulti_name: any = null;
    filterdataobj_rider_type: string = '';
    filteredCustomshelfs: any[] = [];
    filtredCustomSelfObj: any[] = [];

    age: number = 0;
    ageSelectDate = new Date();
    ageSelectedDate: any;
    pouseage: number = 0;
    spageSelectDate: any = new Date();
    spageSelectedDate: any;
    isSelected: boolean = true;


    //flags
    groupfilterFlag: string = '';
    productFlag: string = '';
    productfilterFlag: string = '';
    amRatingFlag: string = '';
    amRatingfilterFlag: string = '';
    surrFlag: string = ''
    surrfilterFlag: string = '';
    riderFlag: string = ''
    strategyFlag: string = ''

    //Guaranteed Income Projection page 
    illustration: boolean = false;
    paginateIllustration: boolean = true;
    showCompareDialog: boolean = false;
    coveredLife: any;
    purchasePay: number = 0;
    initialBenifit: number = 0;
    initial: string = '$';
    carrier: string = '';
    productIllu: string = '';
    riderIllu: string = '';
    illEffectDate = new Date();
    riderAge: any;
    riderFeeIllu: any = '';
    withdrawalPer: number = 0;
    otherVariable: string = '';
    stepups: string = '';
    rollupdata: any[] = [];
    illu_Img: string = '';
    rollUpIllu: any = '';
    rollUpTerm: any = '';
    premium: any = '';
    premiumBonus: any = '';
    benefitBonus: any;
    stateIssue: string = '';
    singleJoinIncome: string = '';
    purchasePayment: string = '';
    benefitBase: string = '';
    deferralPer: any = '';
    waitingPer: any;
    annualIncome: string = '';
    illuStepUps: string = '';
    lifeIncome: string = '';
    productProfile: boolean = false;
    saveSeavch: boolean = false;
    selectedItem: any = null;
    stateName: string = '';
    compareCardsData: any[] = [];
    uploadedFiles: any[] = [];
    urlobj: any[] = [];
    companyName: string = '';
    loogoo: any;
    altImg: string = '../../assets/layout/images/no-picture-available.jpg'

    // productProfileDetails: any[] = [];
    showEllipsis: boolean = true;
    showAccountDescription: boolean = false;
    showFullDescription: boolean = true;
    contributionIncome: string = '';
    monthlyAnnualypaymentType: boolean = true;
    dataView: string = 'grid';
    defaultsettingsvalues: any;
    menuOutsideClickListener: any;
    profileMenuOutsideClickListener: any;
    stateOptions: any[] = [];
    monthlyAnuallyopt: any[] = [];
    allOptionsSelectList: any[] = [];
    sortByDataOption: any = [];
    filteredSavedItem: number = 0;
    compareVariables: boolean = true;

    //////Save Search/////
    searchtitle: string = '';
    loginUserData: any;

    @ViewChild('p') paginator!: Paginator;
    dob: any;
    spouseDob: any;
    dataViewRows: number = 8;
    pageNumber: number = 1;
    pageSize: number = 25;
    withdrawalFrequency: string = 'Annually';
    currentProduct!: any;
    showProductDialog: boolean = false;
    urlSafe: any;
    ownerType: string = 'joint';
    userCustomShelfs: any[] = [];
    customShelfMasterData: any = [];
    showApprovedProductsOnly: boolean = false;
    userShelfProductIds: number[] = [];
    showExportSpinner: boolean = false;
    isFilterChanged: boolean = false;
    allProductRiders: any = [];
    approvedProductIds: number[] = [];
    shelfPermissionIA: string = 'all';
    showOverlay: boolean = false;
    showAcknowledgementDialog: boolean = false;
    searchTitle: any;
    callFirstTime: boolean = false;
    advanceMenuClearAllFilterFlag: boolean = false;
    selectedCustomShelfName: string = 'Select';
    isAdvanceFilterChanged: boolean = false;
    isClickedOnCompare: boolean = false;

    constructor(public layoutService: LayoutService, public renderer: Renderer2, public router: Router,
        private benefitCalculatorService: BenefitcalculatorService,
        private pdfService: PdfService,
        private fb: FormBuilder,
        private datePipe: DatePipe,
        private messageService: MessageService,
        private scrollService: ScrollService,
        public sanitizer: DomSanitizer,
        private http: HttpClient,
        private exportService: ExportService,
        public utilityFunctionService: UtilityFunctionService
    ) {

        let loginSessionData = JSON.parse(sessionStorage.getItem('logInSession') || '');
        let logindata = this.benefitCalculatorService.decryptUsingAES256(loginSessionData);
        this.loginUserData = JSON.parse(logindata);
        this.userShelfProductIds = this.loginUserData.userSelfProductListIndex.map((x: any) => x.productid);
        let approvedProductIds: number[] = this.loginUserData.userSelfProductListIndex_approved.map((x: any) => x.productid);
        this.approvedProductIds = approvedProductIds;
        this.shelfPermissionIA = this.loginUserData.shelfPermissionIA;
        if (this.shelfPermissionIA == 'shelf' || this.shelfPermissionIA == 'd_shelf') {
            this.showApprovedProductsOnly = true;
        }
        this.userlogo = '';
        this.username = this.benefitCalculatorService.get('UserName')[0];
        this.benefitCalculatorService.getStateData().pipe(take(1), debounceTime(400), distinctUntilChanged()).subscribe((res: any) => {
            this.stateData = res;
        });

        // Dropdown Data
        this.genderDataList = [
            { name: 'Select', value: '' },
            { name: 'Male', value: 'M' },
            { name: 'Female', value: 'F' }
        ];
        this.sortByDataOption = [
            { name: 'Withdrawal Amount', value: sortByData.WithdrawalAmount },
            { name: 'Company Name', value: sortByData.CompanyName },
            { name: 'Product Name', value: sortByData.ProductName }
        ];
        this.stateOptions = [
            { label: 'Contribution', value: StateOption.Contribution },
            { label: 'Income', value: StateOption.Income },
        ];
        this.varData = [
            { varName: 'All', value: varData.All },
            { varName: 'Level', value: varData.Level },
            { varName: 'Increasing', value: varData.Increasing },
            { varName: 'Inflation Based', value: varData.InflationBased },
            { varName: 'Tiered Income', value: varData.MaxIncome }
        ]
        this.monthlyAnuallyopt = [
            { label: 'Monthly', value: MonthAnuallyOption.Monthly },
            { label: 'Annually', value: MonthAnuallyOption.Annually },
        ]
        this.allOptionsSelectList = [
            { label: 'Select1', value: allOptions.select1 },
            { label: 'Select2', value: allOptions.select2 },
            { label: 'Select3', value: allOptions.select3 },
        ]
        this.strategyFeeOptions = [
            { strategyFee: 'Yes', value: 1 },
            { strategyFee: 'No', value: 0 },
        ]
        this.confiMultiplier = [
            {
                confiMulti: "Yes"
            },
            {
                confiMulti: "No"
            }
        ];

    }

    ngOnInit(): void {
        // this.activateRouteeUser()
        this.savedtype = '';
        let uID = this.benefitCalculatorService.decryptUsingAES256(JSON.parse(sessionStorage.getItem('userId') || ''));
        this.setDataViewRows();
        let sidebarObject: any = sessionStorage.getItem('sidebarObject');
        if (sidebarObject && this.benefitCalculatorService.resultSet && this.benefitCalculatorService.resultSet.productRiders) {
            this.gridData = this.benefitCalculatorService.resultSet.productRiders;
            this.filteredArray = JSON.parse(JSON.stringify(this.gridData));
            this.periodeam = this.benefitCalculatorService.resultSet.periodeam;
            this.showApprovedProductsOnly = this.benefitCalculatorService.resultSet.showApprovedProductsOnly;
            this.dataView = this.benefitCalculatorService.resultSet.dataView;
            this.totalCompare = this.benefitCalculatorService.resultSet.totalCompare;
            this.checked = this.benefitCalculatorService.resultSet.checked;
            this.compareData = this.benefitCalculatorService.resultSet.compareData;
            this.totalMatches = this.benefitCalculatorService.resultSet.totalMatches;
            if (this.compareData.length > 0) {
                this.isCompare = true;
            }
            this.setSidebarData(this.benefitCalculatorService.resultSet.data, JSON.parse(sidebarObject));
        }
        this.isLoader = true;
        // Getting Default Setting Data
        this.benefitCalculatorService.getDefaultSetting(JSON.parse(uID)).pipe(take(1)).subscribe((res) => {
            if(this.filteredArray.length > 0){
                this.isLoader = false;
            }
            if (res) {
                this.dataView = this.benefitCalculatorService.resultSet && this.benefitCalculatorService.resultSet.dataView ? this.benefitCalculatorService.resultSet.dataView : res.dataView ? res.dataView : 'grid';
                this.defaultsettingsvalues = res;
                this.contributionIncome = res.contribution === 0 ? 'contribution' : 'income';
                // this.monthlyAnnualypaymentType = res.paymentType
                for (let i = 0; i < this.stateData.length; i++) {
                    if (res.userState == this.stateData[i].stateCode) {
                        this.selectedStateName = this.stateData[i].stateName;
                    }
                }
                let caseFilterObj: any = sessionStorage.getItem('basicFilterObj');
                let caseFilterObjParsed: any;
                if(!caseFilterObj){
                    this.topbarForm.patchValue({
                        gender: res.gender,
                        age: res.age || 55,
                        pouseage: res.spouseAge || 55,
                        illinois: res.userState || 'ALL',
                        ridertype: res.riderType || 'All',
                        Contribution: this.contributionIncome,
                        amount: res.amount ? res.amount : 100000,
                        diffperiode: res.defPeriod > 0 ? res.defPeriod : 0,
                    });
                }else{
                    caseFilterObjParsed = JSON.parse(caseFilterObj);
                    this.topbarForm.patchValue({
                        gender: caseFilterObjParsed.gender,
                        age: caseFilterObjParsed.age || 55,
                        pouseage: caseFilterObjParsed.spouseAge || 55,
                        illinois: caseFilterObjParsed.stateCode || 'ALL',
                        ridertype: caseFilterObjParsed.benefitBaseType || 'All',
                        Contribution: this.contributionIncome,
                        amount: caseFilterObjParsed.amount ? caseFilterObjParsed.amount : 100000,
                        diffperiode: caseFilterObjParsed.deferralYear,
                    });
                    this.dataView = caseFilterObjParsed.dataView ? caseFilterObjParsed.dataView : 'grid';
                }
                this.ageSelectDate = new Date();
                this.ageSelectDate.setFullYear(this.ageSelectDate.getFullYear() - Number(!caseFilterObj ? res.age : caseFilterObjParsed.age ? caseFilterObjParsed.age : 55));
                this.ageSelectedDate = this.datePipe.transform(this.ageSelectDate, "MM/dd/yyyy");
                this.spageSelectDate = new Date();
                this.spageSelectDate.setFullYear(this.spageSelectDate.getFullYear() - Number(!caseFilterObj ? res.spouseAge : caseFilterObjParsed.spouseAge ? caseFilterObjParsed.spouseAge : 55));
                this.spageSelectedDate = this.datePipe.transform(this.spageSelectDate, "MM/dd/yyyy")
            } else {
                this.contributionIncome = 'contribution';
                this.topbarForm.patchValue({
                    gender: '',
                    age: 55,
                    pouseage: 55,
                    illinois: 'ALL',
                    ridertype: 'All',
                    Contribution: this.contributionIncome,
                    amount: 100000,
                    diffperiode: 10,
                });
            }
            if (!sidebarObject) {
                this.callFirstTime = true;
                setTimeout(() => {  
                    this.renderData();
                }, 1000);
            } else {
                let basicFilterItem = JSON.parse(sidebarObject);
                let basicFilterObj: any = (sessionStorage.getItem('basicFilterObj'))
                let basicFilterObjfnl = JSON.parse(basicFilterObj)
                this.withdrawalFrequency = basicFilterObjfnl.periode == 1 ? 'Annually' : 'Monthly';
                this.topbarForm.get('pouseage')?.patchValue(basicFilterObjfnl.spage)
                this.topbarForm.get('Contribution')?.patchValue(basicFilterObjfnl.amountType)
                this.topbarForm.get('amount')?.patchValue(basicFilterObjfnl.amount)
                this.topbarForm.get('periode')?.patchValue(basicFilterObjfnl.periode)

                if (basicFilterItem.ageBand < basicFilterObjfnl.spage) {
                    this.topbarForm.get('age')?.patchValue(basicFilterItem.ageBand);
                } else {
                    this.topbarForm.get('age')?.patchValue(basicFilterObjfnl.age);
                }

                if (this.ageSelectDate && res) {
                    this.topbarForm.get('age')?.patchValue(res.age);
                }
                if (this.spageSelectDate && res) {
                    this.topbarForm.get('pouseage')?.patchValue(res.spouseAge);
                }
                this.topbarForm.get('gender')?.patchValue(basicFilterItem.gender);
                this.topbarForm.get('illinois')?.patchValue(basicFilterItem.stateCode);
                this.topbarForm.get('ridertype')?.patchValue(basicFilterItem.benefitBaseType);
                this.topbarForm.get('diffperiode')?.patchValue(basicFilterItem.deferralYear);
                let obj: any = (sessionStorage.getItem('chipDataObject'))
                if (obj != null) {
                    let chipDataObject = JSON.parse(obj)
                    this.filterdataobj_group_name = chipDataObject?.filterdataobj_group_name;
                    this.filterdataobj_products_name = chipDataObject?.filterdataobj_products_name;
                    this.SelectFilter_AMbest_name = chipDataObject?.SelectFilter_AMbest_name;
                    this.filterdataobj_surrender_year_name = chipDataObject?.filterdataobj_surrender_year_name;
                    this.filterdataobj_riderfee_name = chipDataObject?.filterdataobj_riderfee_name;
                    this.filterdataobj_strategyfee_name = chipDataObject?.filterdataobj_strategyfee_name;
                    this.filteredSavedItem = this.filterdataobj_group_name?.length + this.SelectFilter_AMbest_name?.length + this.filterdataobj_surrender_year_name?.length + this.filterdataobj_products_name?.length + this.filterdataobj_strategyfee_name?.length + this.filterdataobj_riderfee_name?.length;
                }
                let objSidebar = JSON.parse(sidebarObject);
                this.ownerType = objSidebar.joint == 'Yes' ? 'joint' : 'single';
                this.topbarForm.get('maritalstatus')?.patchValue(this.ownerType);

                let initCaseInfoFilterObj = sessionStorage.getItem('initBasicFilterObj');
                let caseInfoFilterObj = sessionStorage.getItem('basicFilterObj');
                let isSameInitCaseInfoFilterObj = false;
                if (initCaseInfoFilterObj && caseInfoFilterObj) {
                    let initCaseInfoFilterObjParsed = JSON.parse(initCaseInfoFilterObj);
                    let caseInfoFilterObjParsed = JSON.parse(caseInfoFilterObj);
                    isSameInitCaseInfoFilterObj = JSON.stringify(initCaseInfoFilterObjParsed) == JSON.stringify(caseInfoFilterObjParsed);
                }
                if (this.filteredArray.length === 0) {

                    // Check if 'initSidebarObject' and 'sidebarObject' in localStorage are the same
                    setTimeout(() => {
                        this.renderData(sidebarObject, isSameInitCaseInfoFilterObj ? false : true);
                    }, 1000);
                } else {
                    this.setDOBs();
                    this.setItemMenuList();
                    this.agecheck = this.topbarForm.get('age')?.value || 55;
                    this.spouseagecheck = this.topbarForm.get('pouseage')?.value || 55;
                    this.isFilterChanged = isSameInitCaseInfoFilterObj ? false : true;
                }
            }
        }, (error: any) => {
            this.isLoader = false;
            this.messageService.add({ key: 'tc', severity: 'error', summary: 'Error', detail: 'Failed to load default settings' });
        })
        this.getAllProducsAndCustomShelf();

        // Set isAdvanceFilterChanged to true if chipDataObject exists in local storage
        if (sessionStorage.getItem('chipDataObject')) {
            this.isAdvanceFilterChanged = true;
        }
    }

    ngAfterViewInit(): void {
        // if (window && window.innerWidth && window.innerWidth <= 1440 && window.innerWidth >= 1024) {
        //     (document.body.style as any).zoom = "67%";
        // }
    }

    setItemMenuList() {
        this.items = [{
            label: 'Compare',
            icon: 'bi bi-arrow-left-right',
            command: () => {
                this.onComparebtnchange(this.selectedItem, this.compEvent)
            }
        },
        {
            label: 'Guaranteed Income Projection',
            icon: '"bi bi-file-richtext-fill',
            command: () => {
                this.showIllustration(this.selectedItem);
            }
        },
        {
            label: 'Product Profile',
            icon: 'bi bi-files',
            command: () => {
                if (this.topbarForm.value.illinois == null) {
                    this.messageService.add({ key: 'tc', severity: 'error', summary: 'Error', detail: 'Please Select State' });
                } else if (this.topbarForm.value.illinois == 'ALL') {
                    this.messageService.add({ key: 'tc', severity: 'error', summary: 'Error', detail: 'Select state other than ALL' });
                } else {
                    this.productProfileData = [];
                    this.productProfileData.push(this.topbarForm.value.illinois, this.selectedItem.productid, this.topbarForm.value.pouseage);
                    this.showProductProfile(this.productProfileData);
                }
            }
        }
        ];
        // List view menu button(illustration, product profile, comparison)
        this.itemslist = [{
            label: 'Compare',
            icon: 'bi bi-arrow-left-right',
            command: () => {
                this.onComparebtnchange(this.selectedItem, this.compEvent)
            }
        },
        {
            label: 'Guaranteed Income Projection',
            icon: '"bi bi-file-richtext-fill',
            command: () => {
                this.showIllustration(this.selectedItem);
            }
        },
        {
            label: 'Product Profile',
            icon: 'bi bi-files',
            command: () => {
                if (this.topbarForm.value.illinois == null) {
                    this.messageService.add({ key: 'tc', severity: 'error', summary: 'Error', detail: 'Please Select State' });
                } else if (this.selectedStateName == 'ALL') {
                    this.messageService.add({ key: 'tc', severity: 'error', summary: 'Error', detail: 'Select state other than ALL' });
                } else {
                    this.productProfileData = [];
                    this.productProfileData.push(this.topbarForm.value.illinois, this.selectedItem.productid, this.topbarForm.value.pouseage);
                    this.showProductProfile(this.productProfileData);
                }
            }
        }
        ];
    }

    @HostListener('window:resize', ['$event'])
    onResize(event: any) {
        this.resizeSearchResultDiv();
        this.setDataViewRows();
    }

    resizeSearchResultDiv() {
        if (window.innerWidth < 768) {
            this.showOverlay = true;
        } else {
            this.showOverlay = false;
        }
    }

    setDataViewRows() {
        if (window.innerWidth > 2100) {
            this.dataViewRows = 14;
        } else if (window.innerWidth > 1600 && window.innerWidth < 2101) {
            this.dataViewRows = 10;
        } else if (window.innerWidth > 1024 && window.innerWidth < 1601) {
            this.dataViewRows = 8;
        } else if (window.innerWidth > 600 && window.innerWidth <= 1024) {
            this.dataViewRows = 4;
        } else {
            this.dataViewRows = 1;
        }
    }

    renderData(sidebarObject?: any, isFilterChanged: boolean = false) {
        this.isLoader = true;
        this.filteredArray = [];
        this.gridData = [];
        this.pageNumber = 1;
        this.totalCompare = 0;
        this.compareData = [];
        this.isCompare = false;
        this.checked = false;
        this.isFilterChanged = isFilterChanged;
        if (sidebarObject) {
            this.setDOBs();
            this.topbarForm.get('age')?.patchValue(this.requestValues.ageBand);
            this.topbarForm.get('pouseage')?.patchValue(this.ownerType.toLowerCase() == 'joint' ? this.requestValues.spageBand : 0);
            this.agecheck = Number(this.topbarForm.get('age')?.value);
            this.spouseagecheck = Number(this.topbarForm.get('pouseage')?.value);
            this.amountcheck = Number(this.topbarForm.get('amount')?.value);
            this.diffperiodecheck = Number(this.topbarForm.get('diffperiode')?.value);
            this.getFilterSideBarInit(sidebarObject);
            this.setItemMenuList();
            this.initMenuItems();
        } else {
            this.filterEdit = this.benefitCalculatorService.getsavedData();
            if (this.filterEdit.source._value.length == 2) {
                if (this.filterEdit.source._value[1] == "edit") {
                    this.savedtype = 'edit';
                }
                else if (this.filterEdit.source._value[1] == "view") {
                    this.savedtype = 'view';
                }
            }
            this.setDOBs();
            this.topbarForm.get('age')?.patchValue(this.requestValues.ageBand);
            this.topbarForm.get('pouseage')?.patchValue(this.ownerType.toLowerCase() == 'joint' ? this.requestValues.spageBand : 0);
            // savesearch Data Filter
            const searchTitle = this.filterEdit.source._value.length > 0 ? this.filterEdit.source._value[0].searchtitle : '';
            this.searchTitle = searchTitle;
            if (this.filterEdit.source._value.length === 0 || this.filterEdit.source._value.length === 1) {
                let uID = this.benefitCalculatorService.decryptUsingAES256(JSON.parse(sessionStorage.getItem('userId') || ''));
                this.getFilterSideBar();
            }
            else {
                let filterdatasaved = this.filterEdit.source._value[0].savedstr
                this.filterdataobj_group_name = filterdatasaved.filterdataobj_group_name
                this.filterdataobj_group = filterdatasaved.filterdataobj_group

                this.SelectFilter_AMbest_name = filterdatasaved.SelectFilter_AMbest_name
                this.SelectFilter_AMbest = filterdatasaved.SelectFilter_AMbest

                this.filterdataobj_products_name = filterdatasaved.filterdataobj_products_name
                this.filterdataobj_products = filterdatasaved.filterdataobj_products

                this.filterdataobj_surrender_year_name = filterdatasaved.filterdataobj_surrender_year_name
                this.filterdataobj_surrender_year = filterdatasaved.filterdataobj_surrender_year

                this.filterdataobj_strategyfee_name = filterdatasaved.filterdataobj_strategyfee_name
                this.filterdataobj_strategyfee = filterdatasaved.filterdataobj_strategyfee

                this.filterdataobj_riderfee_name = filterdatasaved.filterdataobj_riderfee_name
                this.filterdataobj_riderfee = filterdatasaved.filterdataobj_riderfee

                this.saveChipData();
                if (this.filterdataobj_group_name.length != 0 || this.SelectFilter_AMbest_name.length != 0 || this.filterdataobj_surrender_year_name.length != 0 || this.filterdataobj_products_name.length != 0 || this.filterdataobj_strategyfee_name.length != 0 || this.filterdataobj_riderfee_name.length != 0) {
                    this.getFilterSideBar();
                }
                this.filteredSavedItem = this.filterdataobj_group_name.length + this.SelectFilter_AMbest_name.length + this.filterdataobj_surrender_year_name.length + this.filterdataobj_products_name.length + this.filterdataobj_strategyfee_name.length + this.filterdataobj_riderfee_name.length;
            }
            this.agecheck = Number(this.topbarForm.get('age')?.value);
            this.spouseagecheck = Number(this.topbarForm.get('pouseage')?.value);
            this.amountcheck = Number(this.topbarForm.get('amount')?.value);
            this.diffperiodecheck = Number(this.topbarForm.get('diffperiode')?.value);
            this.setItemMenuList();
            this.initMenuItems();
            this.isLoader = true;
            this.filteredArray = [];
        }
    }

    showIllustration(item: any) {
        // window.open("https://staging.an.annuitynexus.com/index_annuity/side_by_side/basic_info?ch=,1110,1050,1447", "", "width=1315,height=1000");
        this.illustration = true;
        this.stepups = item.IncomePeriod
        let agedetail: number = 0;
        const spage: number = this.topbarForm.get('pouseage')?.value || 0;
        const age: number = this.topbarForm.get('age')?.value || 0;
        if (this.ownerType.toLowerCase() == 'joint') {
            agedetail = spage > age ? age : spage;
        } else {
            agedetail = age;
        }
        let data = {
            ageBand: agedetail || Number(age),
            deferralYear: this.topbarForm.get('diffperiode')?.value || this.diffperiodecheck,
            is_Joint_Single: this.ownerType.toLowerCase() == 'joint' ? false : true,
            id: item.id,
            contribution: this.topbarForm.get('amount')?.value || 100000,
            amountType: this.topbarForm.get('Contribution')?.value == 'contribution' ? 'contribution' : 'income'
        }
        this.isLoader = true;
        //get illustration page data
        this.benefitCalculatorService.getIllustrationData(data).pipe(take(1)).subscribe((res: any) => {
            this.illustrationResData = res;
            this.illustrationResData.isShelfProduct = this.approvedProductIds.indexOf(item.productid) > -1;//this.userShelfProductIds.indexOf(item.productid) > -1;
            if (res.illustrations.length > 0) {
                res.illustrations.map((x: any) => {
                    x.monthlyWithdrawal = x.annualWithdrawal > 0 ? (x.annualWithdrawal / 12) : 0;
                })
            }
            this.illustrationtblResponse = res.illustrations;
            this.carrier = res.companyName;
            this.productIllu = res.productName;
            this.riderIllu = res.riderName;
            this.riderAge = res.minAge + ' - ' + res.maxAge;
            this.riderFeeIllu = res.riderFee + '%' + ' ' + 'of' + ' ' + res.chargeBasisName;
            this.rollupdata = [];
            this.withdrawalPer = this.ownerType.toLocaleLowerCase() == 'joint' ? res.withdrawalPerJoint : res.withdrawalPer;
            this.otherVariable = res.otherVariable;
            this.rollupdata = this.calculateRollUp(res);
            this.illu_Img = res.logo1 != null ? environment.domain + res.logo1 : this.altImg;
            this.rollUpIllu = res.rollupPerJoint || 0 + '%';
            this.rollUpTerm = item.maxRollupYears || 0 + ' years';
            this.lifeIncome = res.gmwbType;
            // this.premiumBonus = res.premiumBonus == 0 ? 'None' : res.premiumBonus + '%';
            // this.benefitBonus = res.bbBonus == 0 ? 'None' : res.bbBonus + '%';
            this.premiumBonus = item.premiumBonus ? (item.premiumBonus * 100).toFixed(1) + '%' + (item.bonusPercentageBasis ? ' of ' + item.bonusPercentageBasis : '') : 'None';
            this.benefitBonus = (res.bonusPercentage == null || res.bonusPercentage == 0) ? 'None' : res.bonusPercentage.toFixed(1) + `% of ${res.chargeBasisName}`;
            this.stateIssue = this.stateName || '-';
            this.singleJoinIncome = this.topbarForm.get('pouseage')?.value != 0 ? 'Joint' : 'Single';
            this.coveredLife = this.topbarForm.get('pouseage')?.value == 0 ? this.topbarForm.get('age')?.value : (this.topbarForm.get('age')?.value + '/' + this.topbarForm.get('pouseage')?.value);
            this.purchasePay = Number(this.topbarForm.get('amount')?.value);
            this.initialBenifit = item.initialBenefitBase; //((data.contribution) + (((this.topbarForm.get('amount')?.value || 100000) * res.bonusPercentage) / 100) + (((this.topbarForm.get('amount')?.value || 100000) * res.premiumBonus) / 100));
            this.deferralPer = data.deferralYear + ' years';
            this.waitingPer = res.waitingPeriod;
            if(this.topbarForm.get('Contribution')?.value == 'contribution'){
              this.initialBenifit = this.getInitialBenefitBase(item);
            }
            this.annualIncome = '$' + (item.annualIncome.toLocaleString('en')) + ' ' + (item.IncomePeriod);
            this.illuStepUps = res.highAnnivValStepup && res.highAnnivValStepup != '' ? res.highAnnivValStepup : 'None';
            if (this.illu_Img) {
                let myImage = '';
                // myImage = 'https://companylogoss.s3.amazonaws.com/CompanyLogo/105_logo1.jpg';
                if (this.illu_Img.includes('stage-benefitapi.an.annuitynexus.com')) {
                    myImage = this.illu_Img.replace(/\\/g, "/");
                    myImage = myImage.replace("stage-benefitapi.an.annuitynexus.com", "companylogoss.s3.amazonaws.com");
                } else {
                    if (res.logo1 != null) {
                        myImage = "companylogoss.s3.amazonaws.com" + res.logo1;
                        myImage = myImage.replace(/\\/g, "/");
                        myImage = 'https://' + myImage;
                    } else {
                        myImage = this.altImg;
                        myImage = myImage.replace(/\\/g, "/");;
                    }
                }
                this.http.get(myImage, {
                    observe: 'response',
                    responseType: 'blob',
                })
                    .pipe(take(1))
                    .subscribe({
                        next: (res: any) => {
                            var reader = new FileReader();
                            reader.onload = (event) => {
                                this.illu_Img = event.target?.result as any;
                            };
                            reader.readAsDataURL(res.body!);
                        },
                        error: () => { /* image load failure is non-critical — keep existing fallback */ }
                    });
            }
            this.isLoader = false;
        }, (error: any) => {
            this.messageService.add({ key: 'tc', severity: 'error', 
                life: 60000,
                summary: 'Error', detail: 'Something went wrong, please try again' });
            // this.isLoader = false;

            
        });
    }

    hideIllustrationDialog() {
        this.paginateIllustration = true;
    }

    reditectToProduct(productId: number) {
        this.productId = productId;
        this.stateCode = this.topbarForm.get('illinois')?.value || 'ALL';
        this.setProductProfile();
    }

    setOwnerType(ownerType: string) {
        if (this.ownerType != ownerType) {
            if (ownerType.toLowerCase() != 'joint') {
                this.spageSelectDate = new Date();
                this.topbarForm.get('pouseage')?.patchValue(0);
                this.requestValues.pouseage = 0;
                this.spageSelectDate.setFullYear(this.spageSelectDate.getFullYear() - 0);
                this.spageSelectedDate = this.datePipe.transform(this.spageSelectDate, "MM/dd/yyyy")
                this.spouseagecheck = 0;
                this.pouseage = 0;
            } else {
                this.spageSelectDate = new Date(this.ageSelectedDate);
                this.topbarForm.get('pouseage')?.patchValue(Number(this.age));
                this.requestValues.pouseage = Number(this.age);
                this.spageSelectedDate = this.datePipe.transform(this.spageSelectDate, "MM/dd/yyyy")
                this.spouseagecheck = this.age;
                this.pouseage = this.age;
            }
            this.ownerType = ownerType;
            this.renderData(sessionStorage.getItem('sidebarObject'), true);
            // this.paginator.first = 1;
        }
    }

    setProductProfile() {
        this.isLoader = true;
        this.tiker = [];
        this.index = [];
        const apiDomain = environment.domain;
        if (this.stateCode && this.stateCode != 'ALL' && this.stateCode != '') {
            sessionStorage.setItem('selectedStateCode', this.stateCode);
        }
        if (apiDomain == 'https://stage-benefitapi.an.annuitynexus.com') {
            this.router.navigate([`/product-details/indexed/${this.productId}`]);
            // this.redirectUserAnnuityNexus(this.productId);
        } else {
            this.redirectUserAnnuityNexus(this.productId);
        }
    }

    redirectUserAnnuityNexus(productId: number) {
        let loginSessionData = JSON.parse(sessionStorage.getItem('logInSession') || '');
        let logindata = this.benefitCalculatorService.decryptUsingAES256(loginSessionData);
        const loginUserData = JSON.parse(logindata);
        let mainMenuBtnLink = 'https://staging.an.annuitynexus.com/auth?token=';
        if (environment.domain == 'https://benefitapi.annuitynexus.com') {
            mainMenuBtnLink = 'https://an.annuitynexus.com/auth?token=';
        }
        this.benefitCalculatorService.getUser(loginUserData.id).pipe(take(1)).subscribe((res) => {
            if (res.success === true && res.data.userOtp) {
                window.open(`${mainMenuBtnLink}${+(res.data.userOtp)}&profileType=Indexed&productId=${productId}`, "_blank");
            }
        }, (error: any) => {
            this.messageService.add({ key: 'tc', severity: 'error', summary: 'Error', detail: 'Failed to retrieve user data' });
        });
    }

    showProductProfile(item: any) {
        this.stateName = item[0].stateName;
        this.pspouseAge = item[2];
        this.productId = item[1];
        this.stateCode = item[0];
        this.setProductProfile();
    }
    get containerClass() {
        return {
            'layout-theme-light': this.layoutService.config.colorScheme === 'light',
            'layout-theme-dark': this.layoutService.config.colorScheme === 'dark',
            'layout-overlay': this.layoutService.config.menuMode === 'overlay',
            'layout-static': this.layoutService.config.menuMode === 'static',
            'layout-static-inactive': this.layoutService.state.staticMenuDesktopInactive && this.layoutService.config.menuMode === 'static',
            'layout-overlay-active': this.layoutService.state.overlayMenuActive,
            'layout-mobile-active': this.layoutService.state.staticMenuMobileActive,
            'p-input-filled': this.layoutService.config.inputStyle === 'filled',
            'p-ripple-disabled': !this.layoutService.config.ripple
        }
    }
    selectedTrue() {
        this.isSelected = true;
    }
    genderValue(e: any) {
        this.topbarForm.get('gender')?.patchValue(e.value);
        this.requestValues.gender = e.value;
        // this.getFilterSideBar();
        this.renderData(sessionStorage.getItem('sidebarObject'), true);
    }
    onSelectAge(event: any) {
        if (event) {
            var timeDiff = Math.abs(Date.now() - event.getTime());
            this.age = Math.floor(timeDiff / (1000 * 3600 * 24) / 365);
            this.requestValues.ageBand = this.age;
        }
        // this.getFilterSideBar();
        this.renderData(sessionStorage.getItem('sidebarObject'), true);
        // this.paginator.first = 1;
    }
    onCloseAge(event: any) {
        const timeDiff = Math.abs(Date.now() - (new Date(this.ageSelectedDate).getTime()));
        const age = Math.floor(timeDiff / (1000 * 3600 * 24) / 365);
        if (!isNaN(age) && this.ageSelectedDate != this.dob) {
            this.dob = this.ageSelectedDate;
            this.requestValues.ageBand = age;
            this.topbarForm.get('age')?.patchValue(age);
            // this.getFilterSideBar();
            this.renderData(sessionStorage.getItem('sidebarObject'), true);
            // this.paginator.first = 1;
        }
    }
    onEnterAge(e: any) {
        if (e.target.value == 0) {
            this.age = 55;
        }
        if (Number(this.topbarForm.get('age')?.value) != this.agecheck) {
            this.ageSelectDate = new Date();
            this.topbarForm.get('age')?.patchValue(e.target.value == '' || !e.target.value ? 0 : Number(e.target.value));
            this.requestValues.ageBand = e.target.value == '' || !e.target.value ? 0 : Number(e.target.value);
            this.ageSelectDate.setFullYear(this.ageSelectDate.getFullYear() - (e.target.value == '' || !e.target.value ? 0 : Number(e.target.value)));
            this.ageSelectedDate = this.datePipe.transform(this.ageSelectDate, "MM/dd/yyyy")
            this.agecheck = e.target.value == '' || !e.target.value ? 0 : Number(e.target.value);
            //this.getFilterSideBar();
            this.renderData(sessionStorage.getItem('sidebarObject'), true);
            // this.paginator.first = 1;
        }
    }
    onSelectSpouseAge(event: any) {
        if (event) {
            const timeDiff = Math.abs(Date.now() - event.getTime());
            this.pouseage = Math.floor(timeDiff / (1000 * 3600 * 24) / 365);
            this.requestValues.pouseage = this.pouseage;
        }
        //this.getFilterSideBar();
        this.renderData(sessionStorage.getItem('sidebarObject'), true);
        // this.paginator.first = 1;
    }
    onSpouseAgeClose(e: any) {
        const timeDiff = Math.abs(Date.now() - (new Date(this.spageSelectedDate).getTime()));
        const age = Math.floor(timeDiff / (1000 * 3600 * 24) / 365);
        if (!isNaN(age) && this.spageSelectedDate != this.spouseDob) {
            this.spouseDob = this.spageSelectedDate;
            this.requestValues.pouseage = age;
            this.topbarForm.get('pouseage')?.patchValue(age);
            //this.getFilterSideBar();
            this.renderData(sessionStorage.getItem('sidebarObject'), true);
            // this.paginator.first = 1;
        }
    }
    onSpouseAgeSelect(e: any) {
        if (Number(this.topbarForm.get('pouseage')?.value) != this.spouseagecheck) {
            this.spageSelectDate = new Date();
            this.topbarForm.get('pouseage')?.patchValue(e.target.value);
            this.requestValues.pouseage = e.target.value;
            this.spageSelectDate.setFullYear(this.spageSelectDate.getFullYear() - Number(e.target.value));
            this.spageSelectedDate = this.datePipe.transform(this.spageSelectDate, "MM/dd/yyyy")
            this.spouseagecheck = Number(e.target.value);
            //this.getFilterSideBar();
            this.renderData(sessionStorage.getItem('sidebarObject'), true);
            // this.paginator.first = 1;
        }
    }
    onSpouseAgeEnter(e: any) {
        if (e.target.value == 0) {
            this.pouseage = 55;
        }
        this.spageSelectDate = new Date();
        if (Number(this.topbarForm.get('pouseage')?.value) != this.spouseagecheck) {
            this.topbarForm.get('pouseage')?.patchValue(e.target.value == '' || !e.target.value ? 0 : Number(e.target.value));
            this.requestValues.pouseage = e.target.value == '' || !e.target.value ? 0 : Number(e.target.value);
            this.spageSelectDate.setFullYear(this.spageSelectDate.getFullYear() - (e.target.value == '' || !e.target.value ? 0 : Number(e.target.value)));
            this.spageSelectedDate = this.datePipe.transform(this.spageSelectDate, "MM/dd/yyyy")
            this.spouseagecheck = (e.target.value == '' || !e.target.value ? 0 : Number(e.target.value));
            this.pouseage = e.target.value == '' || !e.target.value ? 0 : e.target.value;
            // this.getFilterSideBar();
            this.renderData(sessionStorage.getItem('sidebarObject'), true);
            // this.paginator.first = 1;
        }
    }

    onStateChange(e: any) {
        sessionStorage.setItem('stateName', e.originalEvent.target.innerText)
        this.selectedStateName = e.originalEvent.target.innerText;
        this.amRatingFlag = "";
        this.productfilterFlag = "";
        this.surrFlag = "";
        this.strategyFlag = "";
        this.riderFlag = "";
        this.groupfilterFlag = "";
        this.stateCodeFilter = e.value;
        //this.getFilterSideBar();
        this.renderData(sessionStorage.getItem('sidebarObject'), true);
        // this.paginator.first = 1;
        if (this.filteredArray.length > 8) {
            this.ispagination = true
        } else {
            this.ispagination = false
        }
    }
    onStateClear(e: any) {
        this.filteredArray = this.gridData;
        // this.totalMatches = this.filteredArray.length;
        if (this.filteredArray.length > 8) {
            this.ispagination = true
        } else {
            this.ispagination = false
        }
    }
    onVarChange(e: any) {
        this.amRatingFlag = "";
        this.productfilterFlag = "";
        this.surrFlag = "";
        this.strategyFlag = "";
        this.riderFlag = "";
        this.groupfilterFlag = "";
        this.benifitBaseType = [];
        this.filterdataobj_rider_type = e.value;
        //this.getFilterSideBar()
        this.renderData(sessionStorage.getItem('sidebarObject'), true);
        // this.paginator.first = 1;
    }

    calculateRollUp(data: any) {
        let rollUpdata = [];
        if (this.topbarForm.get('pouseage')?.value != 0) {
            if (data.rollupPerJoint && data.rollupPerJoint.trim() != "") {
                const rollUpPerArray = data.rollupPerJoint.split(',');
                const rollupYearsArray = data.rollupYears ? data.rollupYears.split(',') : data.maxRollupYears.split(',');
                const rollupIsSimpleCompArray = data.rollupIsSimpleComp.split(',');
                for (let index = 0; index < rollUpPerArray.length; index++) {
                    let rollUpText: any = rollUpPerArray[index] + '% ' + rollupIsSimpleCompArray[index] + ' / Years ' + rollupYearsArray[index];
                    rollUpdata.push(rollUpText);
                }
            }
        } else {
            if (data.rollupPer && data.rollupPer.trim() != "") {
                const rollUpPerArray = data.rollupPer.split(',');
                const rollupYearsArray = data.rollupYears ? data.rollupYears.split(',') : data.maxRollupYears.split(',');
                const rollupIsSimpleCompArray = data.rollupIsSimpleComp.split(',');
                for (let index = 0; index < rollUpPerArray.length; index++) {
                    let rollUpText: any = rollUpPerArray[index] + '% ' + rollupIsSimpleCompArray[index] + ' / Years ' + rollupYearsArray[index];
                    rollUpdata.push(rollUpText);
                }
            }
        }
        return rollUpdata;
    }

    contIncome(e: any) {
        this.totalCompare = 0;
        this.compareData = [];
        this.checked = false;
        this.isCompare = false;
        this.compareVariables = true;
        const filteredArray = JSON.parse(JSON.stringify(this.filteredArray));
        this.gridData = []
        this.filteredArray = [];
        let counter = 0;
        for (const data of filteredArray) {
            const gridItem =  { ...this.buildProductItem(data, counter) };
            gridItem.IncomePeriod = this.topbarForm.get('Contribution')?.value == 'contribution' ? (this.topbarForm.get('periode')?.value ? 'Est. Annual Inc.' : 'Est. Monthly Inc.') : 'Est. Initial Contrib.';
            if(this.topbarForm.get('Contribution')?.value == 'contribution'){
              gridItem.initialBenefitBase = this.getInitialBenefitBase(data);
            }
            delete (gridItem as any).waitingTerm;
            delete (gridItem as any).waitingPeriod;
            delete (gridItem as any).chargeFreqDeductedWhen;

            this.gridData.push(gridItem);
            const filteredItem = { ...this.buildProductItem(data, counter) };
            filteredItem.IncomePeriod = this.topbarForm.get('Contribution')?.value == 'contribution' ? (this.topbarForm.get('periode')?.value ? 'Est. Annual Inc.' : 'Est. Monthly Inc.') : 'Est. Initial Contrib.';
            if(this.topbarForm.get('Contribution')?.value == 'contribution'){
              filteredItem.initialBenefitBase = this.getInitialBenefitBase(data);
            }
            delete (filteredItem as any).waitingTerm;
            delete (filteredItem as any).waitingPeriod;
            delete (filteredItem as any).chargeFreqDeductedWhen;
            this.filteredArray.push(filteredItem);
            counter++;
        }



        let basicFilterObj: any = this.getBasicFilterObj()
        sessionStorage.setItem("basicFilterObj", JSON.stringify(basicFilterObj));
        this.benefitCalculatorService.resultSet['productRiders'] = JSON.parse(JSON.stringify(this.gridData))
    }
    onAmountSelect(e: any) {
        if (e && e.target.value && Number(this.topbarForm.get('amount')?.value) != this.amountcheck) {
            this.topbarForm.get('amount')?.patchValue(e.target.value.replaceAll(',', ''));
            this.amountcheck = Number(this.topbarForm.get('amount')?.value);
            // this.getFilterSideBar()
            this.renderData(sessionStorage.getItem('sidebarObject'), true);
            // this.paginator.first = 1;
        }
    }

    periodChange(event: any) {
        this.totalCompare = 0;
        this.compareData = [];
        this.isCompare = false;
        this.checked = false;
        this.withdrawalFrequency = event.option.label;
        this.compareVariables = true;
        const filteredArray = structuredClone(this.filteredArray);
        this.filteredArray = [];
        this.gridData = [];
        let counter = 0;
        for (const data of filteredArray) {
            const gridItem =  { ...this.buildProductItem(data, counter) };
            gridItem.IncomePeriod = this.topbarForm.get('Contribution')?.value == 'contribution' ? (this.topbarForm.get('periode')?.value ? 'Est. Annual Inc.' : 'Est. Monthly Inc.') : 'Est. Initial Contrib.';
            delete (gridItem as any).waitingTerm;
            delete (gridItem as any).waitingPeriod;
            delete (gridItem as any).chargeFreqDeductedWhen;

            this.gridData.push(gridItem);
            const filteredItem = { ...this.buildProductItem(data, counter) };
            filteredItem.IncomePeriod = this.topbarForm.get('Contribution')?.value == 'contribution' ? (this.topbarForm.get('periode')?.value ? 'Est. Annual Inc.' : 'Est. Monthly Inc.') : 'Est. Initial Contrib.';
            delete (filteredItem as any).waitingTerm;
            delete (filteredItem as any).waitingPeriod;
            delete (filteredItem as any).chargeFreqDeductedWhen;
            this.filteredArray.push(filteredItem);
            counter++;
        }

        let basicFilterObj: any = this.getBasicFilterObj()
        sessionStorage.setItem("basicFilterObj", JSON.stringify(basicFilterObj));
        this.benefitCalculatorService.resultSet['productRiders'] = JSON.parse(JSON.stringify(this.gridData))
    }
    updateDeffChange(e: any) {
        if (e && e.target.value && Number(this.topbarForm.get('diffperiode')?.value) != this.diffperiodecheck) {
            this.topbarForm.get('diffperiode')?.patchValue(e.target.value);
            this.requestValues.deferralYear = e.target.value;
            this.diffperiodecheck = e.target.value;
            // this.getFilterSideBar();
            this.renderData(sessionStorage.getItem('sidebarObject'), true);
            // this.paginator.first = 1;
        }
    }
    updateDeffSliderChange(e: any) {
        if (Number(this.topbarForm.get('diffperiode')?.value) != this.diffperiodecheck) {
            this.topbarForm.get('diffperiode')?.patchValue(e.value);
            this.requestValues.deferralYear = e.value;
            this.diffperiodecheck = e.value;
            // this.getFilterSideBar();
            this.renderData(sessionStorage.getItem('sidebarObject'), true);
            // this.paginator.first = 1;
        }
    }
    onHideShow() {
        this.showmodel = true;
    }
    ontabSelect(status: string) {
        this.selectedtab = status;
    }
    onbackClick() {
        this.selectedtab = 'Sidebar';
    }
    shortbyFilters(val: any) {
        this.selectedSortBy = val.value;
        this.selectedSortBymodel = val.value;
        this.filterdataobj_short.push(val.value);

        if (this.selectedSortBy === 'Withdrawal Amount') {
            this.gridData = this.gridData.sort((a: any, b: any) => (a.annualIncome > b.annualIncome) ? -1 : 1);
            // this.paginator.first = 1;
        }
        else if (this.selectedSortBy === 'Company Name') {
            this.gridData = this.gridData.sort((a: any, b: any) => (a.companyName > b.companyName) ? 1 : -1);
            // this.paginator.first = 1;
        }
        else if (this.selectedSortBy === 'Product Name') {
            this.gridData = this.gridData.sort((a: any, b: any) => (a.productName > b.productName) ? 1 : -1);
            // this.paginator.first = 1;
        }
        else {
            this.filteredArray = [...this.gridData];

            if (this.filteredArray.length > 8) {
                this.ispagination = true
            } else {
                this.ispagination = false
            }
        }
        this.filteredArray = [...this.gridData];

        if (this.filteredArray.length > 8) {
            this.ispagination = true
        } else {
            this.ispagination = false
        }
    }
    onGroupSelect(event: any) {
        this.filterdataobj_group = [];
        this.filterdataobj_group_name = [];
        this.amRatingFlag = ""
        this.productfilterFlag = ""
        this.surrFlag = ""
        this.strategyFlag = ""
        this.riderFlag = ""
        this.groupfilterFlag = "Groups"

        if (event && event.value.length > 0) {
            for (let i = 0; i < event.value.length; i++) {
                if (event.value[i].groupId) {
                    this.filterdataobj_group.push(event.value[i].groupId);
                    this.filterdataobj_group_name.push({ groupName: event.value[i].groupName, groupId: event.value[i].groupId })
                }
            }
            const selectedGroups = JSON.parse(JSON.stringify(this.filterdataobj_group_name));
            this.getFilterSideBar();
            // this.paginator.first = 1;
            this.filteredSavedItem = this.filterdataobj_group_name.length + this.SelectFilter_AMbest_name.length + this.filterdataobj_surrender_year_name.length + this.filterdataobj_products_name.length + this.filterdataobj_strategyfee_name.length + this.filterdataobj_riderfee_name.length;

            this.saveChipData();
        }
        else {
            this.saveChipData();
            this.getFilterSideBar();
            // this.paginator.first = 1;
            this.filteredSavedItem = this.filteredSavedItem - 1;
        }

    }
    onProductSelect(event: any) {
        if (event.node.children === undefined) {
            let { node } = event;
            this.filterdataobj_products.push(node.key);
            this.filterdataobj_products_name.push({
                key: node.key,
                label: node.label,
                data: node.data
            });
            this.productfilterFlag = "Product";
            this.groupfilterFlag = "";
            this.amRatingFlag = "";
            this.surrFlag = ""
            this.strategyFlag = ""
            this.riderFlag = ""

            this.getFilterSideBar();
            // this.paginator.first = 1;
            this.filteredSavedItem = this.filterdataobj_group_name.length + this.SelectFilter_AMbest_name.length + this.filterdataobj_surrender_year_name.length + this.filterdataobj_products_name.length + this.filterdataobj_strategyfee_name.length + this.filterdataobj_riderfee_name.length;
            this.saveChipData();
        }
        else {
            const { node: { children } } = event;
            if (Array.isArray(children) && children.length) {
                for (let val of children) {
                    this.filterdataobj_products.filter((el: any, index: any) => {
                        if (el === val.key) {
                            this.filterdataobj_products.splice(index, 1);
                        }
                    })
                    this.filterdataobj_products.push(val.key)

                    this.filterdataobj_products_name.filter((el: any, index: any) => {
                        if (el.key === val.key) {
                            this.filterdataobj_products_name.splice(index, 1);
                        }
                    })
                    this.filterdataobj_products_name.push({
                        key: val.key,
                        label: val.label,
                        data: val.data
                    });
                }
            }
            this.productfilterFlag = "Product";
            this.groupfilterFlag = "";
            this.amRatingFlag = "";
            this.surrFlag = ""
            this.strategyFlag = ""
            this.riderFlag = ""
            this.getFilterSideBar();
            // this.paginator.first = 1;
            this.filteredSavedItem = this.filterdataobj_group_name.length + this.SelectFilter_AMbest_name.length + this.filterdataobj_surrender_year_name.length + this.filterdataobj_products_name.length + this.filterdataobj_strategyfee_name.length + this.filterdataobj_riderfee_name.length;

            this.saveChipData();

        }
    };
    onProductRemove(event: any) {
        if (event.node.children === undefined) {
            const { node } = event;
            let element: any[] = [];
            if (node) element = this.filterdataobj_products.filter((val: any) => {
                return node.key === val
            })
            element.filter((res: any) => {
                this.filterdataobj_products.filter((data: any, index: any) => {
                    if (res === data) {
                        this.filterdataobj_products.splice(index, 1);

                    }
                })
            })
            element.filter((res: any) => {
                this.filterdataobj_products_name.filter((data: any, index: any) => {
                    if (res === data.key) {
                        this.filterdataobj_products_name.splice(index, 1)

                    }
                })
            })

            this.productfilterFlag = "Product";
            this.groupfilterFlag = "";
            this.amRatingFlag = "";
            this.surrFlag = ""
            this.strategyFlag = ""
            this.riderFlag = ""
            this.getFilterSideBar();
            // this.paginator.first = 1;

            this.saveChipData();

            if (this.filterdataobj_products_name.length == 0) {
            }
            this.filteredSavedItem = this.filteredSavedItem - 1;

        }
        else {

            const { node: { children } } = event;
            let element: any[] = [];
            if (children) element = this.filterdataobj_products.filter((val: any) => {
                return children.some((el: any) => el.key === val)
            })

            element.filter((res: any) => {
                this.filterdataobj_products.filter((data: any, index: any) => {
                    if (res === data) {
                        this.filterdataobj_products.splice(index, 1);
                    }
                })
            })
            element.filter((res: any) => {
                this.filterdataobj_products_name.filter((data: any, index: any) => {
                    if (res === data.key) {
                        this.filterdataobj_products_name.splice(index, 1)
                    }
                })
            })
            this.productfilterFlag = "Product";
            this.groupfilterFlag = "";
            this.amRatingFlag = "";
            this.surrFlag = ""
            this.strategyFlag = ""
            this.riderFlag = ""
            this.getFilterSideBar();
            // this.paginator.first = 1;

            this.saveChipData();

            if (this.filterdataobj_products_name.length == 0) {
            }
            if (this.filteredSavedItem >= 2) {
                this.filteredSavedItem = 0
            } else {
                this.filteredSavedItem = this.filteredSavedItem - 1;
            }
        }
    }
    onAMReatingSelect(event: any) {
        this.SelectFilter_AMbest = [];
        this.SelectFilter_AMbest_name = [];
        this.productfilterFlag = ""
        this.groupfilterFlag = ""
        this.surrFlag = ""
        this.strategyFlag = ""
        this.riderFlag = ""
        this.amRatingFlag = "amBests";

        if (event && event.value.length > 0) {

            for (let i = 0; i < event.value.length; i++) {

                if (event.value[i].bestid) {
                    this.SelectFilter_AMbest.push(event.value[i].bestid);
                    this.SelectFilter_AMbest_name.push({ bestid: event.value[i].bestid })

                }

                this.saveChipData();
            }
            this.getFilterSideBar();
            // this.paginator.first = 1;
            this.filteredSavedItem = this.filterdataobj_group_name.length + this.SelectFilter_AMbest_name.length + this.filterdataobj_surrender_year_name.length + this.filterdataobj_products_name.length + this.filterdataobj_strategyfee_name.length + this.filterdataobj_riderfee_name.length;

        } else {

            this.saveChipData();
            this.getFilterSideBar()
            // this.paginator.first = 1;
            this.filteredSavedItem = this.filteredSavedItem - 1
        }
    }
    onSurYearSelect(event: any) {
        this.filterdataobj_surrender_year = [];
        this.filterdataobj_surrender_year_name = [];
        this.amRatingFlag = ""
        this.productfilterFlag = ""
        this.groupfilterFlag = ""
        this.surrfilterFlag = "";
        this.strategyFlag = ""
        this.riderFlag = ""
        this.surrFlag = "surrYrs"

        if (event && event.value.length > 0) {

            for (let i = 0; i < event.value.length; i++) {

                if (event.value[i].surryr) {
                    this.filterdataobj_surrender_year.push(event.value[i].surryr);
                    this.filterdataobj_surrender_year_name.push({ surryr: event.value[i].surryr })
                }

                this.saveChipData();
            }
            this.getFilterSideBar();
            // this.paginator.first = 1;
            this.filteredSavedItem = this.filterdataobj_group_name.length + this.SelectFilter_AMbest_name.length + this.filterdataobj_surrender_year_name.length + this.filterdataobj_products_name.length + this.filterdataobj_strategyfee_name.length + this.filterdataobj_riderfee_name.length;

        } else {
            this.getFilterSideBar();
            // this.paginator.first = 1;
            this.filteredSavedItem = this.filteredSavedItem - 1;
        }

    }
    onRiderFeeSelect(event: any) {
        this.amRatingFlag = ""
        this.productfilterFlag = ""
        this.groupfilterFlag = ""
        this.surrFlag = ""
        this.strategyFlag = ""
        this.riderFlag = 'riderFee'
        this.filterdataobj_riderfee = [];
        this.filterdataobj_riderfee_name = [];

        if (event.value) {
            this.filterdataobj_riderfee.push(String(event.value.riderFee));
            this.filterdataobj_riderfee_name.push({ riderFee: String(event.value.riderFee) });

            this.saveChipData();
        }
        this.getFilterSideBar();
        // this.paginator.first = 1;
        this.filteredSavedItem = this.filterdataobj_group_name.length + this.SelectFilter_AMbest_name.length + this.filterdataobj_surrender_year_name.length + this.filterdataobj_products_name.length + this.filterdataobj_strategyfee_name.length + this.filterdataobj_riderfee_name.length;
    }
    onStrategyFeeSelect(event: any) {
        this.amRatingFlag = ""
        this.productfilterFlag = ""
        this.groupfilterFlag = ""
        this.surrFlag = ""
        this.riderFlag = ""
        this.strategyFlag = 'strategyFees'
        this.filterdataobj_strategyfee = [];
        this.filterdataobj_strategyfee_name = [];
        if (event.value) {
            this.filterdataobj_strategyfee.push({ strategyFee: event.value.value });
            this.filterdataobj_strategyfee_name.push({ strategyFee: event.value.strategyFee });
        }
        this.saveChipData();
        this.getFilterSideBar();
        // this.paginator.first = 1;
        this.filteredSavedItem = this.filterdataobj_group_name.length + this.SelectFilter_AMbest_name.length + this.filterdataobj_surrender_year_name.length + this.filterdataobj_products_name.length + this.filterdataobj_strategyfee_name.length + this.filterdataobj_riderfee_name.length;
    }
    onConfiMultiSelect(event: any) {
        let { value } = event;
        this.filterdataobj_confiMulti_name = value;
        this.getFilterSideBar();
        // this.paginator.first = 1;
        this.filteredSavedItem = this.filterdataobj_group_name.length + this.SelectFilter_AMbest_name.length + this.filterdataobj_surrender_year_name.length + this.filterdataobj_products_name.length + this.filterdataobj_strategyfee_name.length + this.filterdataobj_riderfee_name.length;
    }
    removeTags(item: any): void {
        let index: number = 0;
        if (item.groupName !== undefined) {
            index = this.filterdataobj_group.findIndex((e: any) => e === item.groupId);
            this.filterdataobj_group.splice(index, 1);

            index = this.filterdataobj_group_name.findIndex((e: any) => e.groupId === item.groupId);
            this.filterdataobj_group_name.splice(index, 1);
            this.selectedGroups = [...this.filterdataobj_group_name];

            this.saveChipData();
            this.filteredSavedItem = this.filteredSavedItem - 1
        }
        if (item.bestid !== undefined) {

            index = this.SelectFilter_AMbest.findIndex((e: any) => e == item.bestid);
            this.SelectFilter_AMbest.splice(index, 1);

            index = this.SelectFilter_AMbest_name.findIndex((e: any) => e.bestid == item.bestid);
            this.SelectFilter_AMbest_name.splice(index, 1);
            this.selectedAMBestrating = [...this.SelectFilter_AMbest_name];

            this.saveChipData();
            this.filteredSavedItem = this.filteredSavedItem - 1
        }
        if (item.surryr !== undefined) {

            index = this.filterdataobj_surrender_year.findIndex((e: any) => e === item.surryr);
            this.filterdataobj_surrender_year.splice(index, 1);
            index = this.filterdataobj_surrender_year_name.findIndex((e: any) => e.surryr === item.surryr);
            this.filterdataobj_surrender_year_name.splice(index, 1);
            this.selectedSuryear = [...this.filterdataobj_surrender_year_name];
            this.saveChipData();
            this.filteredSavedItem = this.filteredSavedItem - 1
        }
        if (item.strategyFee !== undefined) {

            // index = this.filterdataobj_strategyfee.findIndex((e: any) => e.strategyFee === item.strategyFee);
            // this.filterdataobj_strategyfee.splice(index, 1);
            // index = this.filterdataobj_strategyfee_name.findIndex((e: any) => e.strategyFee === item.strategyFee);
            // this.filterdataobj_strategyfee_name.splice(index, 1);

            index = this.filterdataobj_strategyfee.findIndex((e: any) => e.strategyFee === this.strategyFeeOptions.find(x => x.strategyFee == item.strategyFee).value);
            if (index > -1) {
                this.filterdataobj_strategyfee.splice(index, 1);
            }
            index = this.filterdataobj_strategyfee_name.findIndex((e: any) => e.strategyFee === item.strategyFee);
            if (index > -1) {
                this.filterdataobj_strategyfee_name.splice(index, 1);
            }
            this.selectedStrategyFee = [...this.filterdataobj_strategyfee_name]
            this.saveChipData();
            this.filteredSavedItem = this.filteredSavedItem - 1
        }
        if (item.riderFee !== undefined) {
            index = this.filterdataobj_riderfee.findIndex((e: any) => e.riderFee === item.riderFee);
            this.filterdataobj_riderfee.splice(index, 1);
            index = this.filterdataobj_riderfee_name.findIndex((e: any) => e.riderFee === item.riderFee);
            this.filterdataobj_riderfee_name.splice(index, 1);
            this.selectedRiderFee = [...this.filterdataobj_riderfee_name]
            this.saveChipData();
            this.filteredSavedItem = this.filteredSavedItem - 1
        }
        if (item.confiMulti !== undefined) {
            this.SelectFilter6 = [];
            this.filteredSavedItem = this.filteredSavedItem - 1
        }
        if (item.data !== undefined) {
            index = this.filterdataobj_products.findIndex((e: any) => e === item.key);
            this.filterdataobj_products.splice(index, 1);
            index = this.filterdataobj_products_name.findIndex((e: any) => e.key === item.key);
            this.filterdataobj_products_name.splice(index, 1);
            this.selectedProducts = [...this.filterdataobj_products_name];
            this.saveChipData();
            this.filteredSavedItem = this.filteredSavedItem - 1
        }
        this.getFilterSideBar();
        // this.paginator.first = 1;
    }
    clearallFilter() {

        this.groupfilterFlag = '';

        this.productFlag = '';
        this.productfilterFlag = '';

        this.amRatingFlag = '';
        this.amRatingfilterFlag = '';

        this.riderFlag = ""
        this.strategyFlag = ""

        this.surrFlag = ''
        this.surrfilterFlag = '';

        this.filterdataobj_group = [];
        this.filterdataobj_group_name = [];
        this.SelectFilter_AMbest = [];
        this.SelectFilter_AMbest_name = []
        this.filterdataobj_surrender_year = [];
        this.filterdataobj_surrender_year_name = [];

        this.filterdataobj_products = [];
        this.filterdataobj_products_name = [];
        this.filterdataobj_riderfee = [];
        this.filterdataobj_riderfee_name = [];
        this.filterdataobj_strategyfee = [];
        this.filterdataobj_strategyfee_name = [];

        this.selectedGroups = [];
        this.selectedAMBestrating = [];
        this.selectedStrategyFee = [];
        this.selectedSuryear = [];
        this.selectedRiderFee = [];
        this.selectedProducts = [];
        sessionStorage.removeItem('sessionGroup');
        sessionStorage.removeItem('sessionProduct');
        sessionStorage.removeItem('sidebarObject');
        sessionStorage.removeItem('chipDataObject');
        this.IsCustomShelf = false;
        this.filtredCustomSelfObj = [];
        this.getFilterSideBar();
        // this.paginator.first = 1;
        this.filteredSavedItem = this.filterdataobj_group_name.length + this.SelectFilter_AMbest_name.length + this.filterdataobj_surrender_year_name.length + this.filterdataobj_products_name.length + this.filterdataobj_strategyfee_name.length + this.filterdataobj_riderfee_name.length;
    }

    getAnnualIncome(data: any, returnInitialBenefitBase: boolean = false): number {
        const isContribution = this.topbarForm.get('Contribution')?.value === 'contribution';
        const isAnnual = !!this.topbarForm.get('periode')?.value;
        const amount = this.topbarForm.get('amount')?.value ?? 0;
        let isJoint = false;
        if (this.ownerType.toLowerCase() == 'joint') {
            isJoint = true;
        }
        let income: number;
        if (isContribution) {
            income = isJoint
                ? data.factorJoint * amount
                : data.factorSingle * amount;
        
            if (!isAnnual) {
                income = income / 12;
            }
        } else {
            if (!isAnnual) {
                income = (amount * 12) / (isJoint ? data.factorJoint : data.factorSingle);
              
            }else{
                income = isJoint
                ? amount / data.factorJoint
                : amount / data.factorSingle;
            }
        }
        if(returnInitialBenefitBase){
            if (data.isGmwbBonusBenefitBase) {
            income = ((income) + (((income) * data.bonusPercentage) / 100));
            }
            if (data.isBonusBenefitBase) {
                income = ((income) + (((income) * data.premiumBonus) / 100));
            }
        }
        return Math.round(income);
    }

    getFilterSideBar(isExport: boolean = false) {
        let groupIds = [];
        let productIds: any = [];
        let amBestRatingIds = [];
        let surrYearIds = [];
        let riderFeeId: any;
        let strategyFeeId: any;
        let coMultiplier: any;
        // let riderTypes: any;
        let basicFilterObj: any = this.getBasicFilterObj()
        this.withdrawalFrequency = basicFilterObj.periode == 1 ? 'Annually' : 'Monthly';
        sessionStorage.setItem("basicFilterObj", JSON.stringify(basicFilterObj));
        if (this.filterdataobj_group != undefined) {
            for (let i = 0; i < this.filterdataobj_group.length; i++) {
                if (this.filterdataobj_group[i]) {
                    groupIds.push(this.filterdataobj_group[i]);
                }
            }
        }
        if (this.filterdataobj_products != undefined) {
            for (let i = 0; i < this.filterdataobj_products.length; i++) {
                if (this.filterdataobj_products[i]) {
                    productIds.push(this.filterdataobj_products[i]);
                }

            }
        }
        if (this.SelectFilter_AMbest != undefined) {
            for (let i = 0; i < this.SelectFilter_AMbest.length; i++) {
                if (this.SelectFilter_AMbest[i]) {
                    amBestRatingIds.push(this.SelectFilter_AMbest[i]);
                }
            }
        }
        if (this.filterdataobj_surrender_year != undefined) {
            for (let i = 0; i < this.filterdataobj_surrender_year.length; i++) {
                if (this.filterdataobj_surrender_year[i]) {
                    surrYearIds.push(this.filterdataobj_surrender_year[i]);
                }
            }
        }
        if (this.filterdataobj_riderfee != undefined) {
            if (this.filterdataobj_riderfee[0]) {
                riderFeeId = this.filterdataobj_riderfee[0];
            }
        }
        if (this.filterdataobj_strategyfee != undefined) {
            if (this.filterdataobj_strategyfee[0]) {
                strategyFeeId = this.filterdataobj_strategyfee[0].strategyFee;
            } else {
                strategyFeeId = 2;
            }
        }
        if (this.filterdataobj_confiMulti_name != undefined) {
            if (this.filterdataobj_confiMulti_name) {
                coMultiplier = this.filterdataobj_confiMulti_name.confiMulti?.toLowerCase() === 'yes' ? true : false;
            }
        }
        var spage: number = this.topbarForm.get('pouseage')?.value || 55;
        var age: number = this.topbarForm.get('age')?.value || 55;
        var agedetail: number = spage > age ? age : spage;
        const sidebarObj: any = {
            "ageBand": agedetail || Number(age),
            "deferralYear": this.topbarForm.get('diffperiode')?.value,
            "gender": this.topbarForm.get('gender')?.value || '',
            "groupId": groupIds || [],
            "productId": productIds || [],
            "amBestRating": amBestRatingIds || [],
            "surrYear": surrYearIds || [],
            "riderFee": riderFeeId === undefined || riderFeeId === null ? null : riderFeeId,
            "strategyFee": (strategyFeeId == 0 || strategyFeeId == 1) ? strategyFeeId : 2,
            "coMultiplier": coMultiplier === undefined || coMultiplier === null ? null : coMultiplier,
            "benefitBaseType": this.topbarForm.get('ridertype')?.value,
            "stateCode": this.topbarForm.get('illinois')?.value
        }
        sidebarObj.sortBy = sidebarObj.sortBy ? sidebarObj.sortBy : 'WithdrawalAmount';
        //sidebarObj.joint = this.topbarForm.get('pouseage')?.value ? 'Yes' : 'No';
        sidebarObj.joint = this.ownerType.toLowerCase() == 'joint' ? 'Yes' : 'No';
        sidebarObj.approvedProductsOnly = this.showApprovedProductsOnly;
        sidebarObj.age = basicFilterObj.age;
        sidebarObj.spage = basicFilterObj.spage;
        sidebarObj.amount = basicFilterObj.amount;
        sidebarObj.amountType = basicFilterObj.amountType;
        sidebarObj.periode = basicFilterObj.periode;
        sidebarObj.spageBand = this.ownerType.toLowerCase() == 'joint' ? this.topbarForm.get('pouseage')?.value || 55 : 0;
        sessionStorage.setItem("sidebarObject", JSON.stringify(sidebarObj));
        if (this.callFirstTime) {
            sessionStorage.setItem("initSidebarObject", JSON.stringify(sidebarObj));
            this.callFirstTime = false;
        }
        if(!sessionStorage.getItem('initBasicFilterObj')){
            sessionStorage.setItem("initBasicFilterObj", JSON.stringify(basicFilterObj));
        }
        this.pageNumber = 1;
        sidebarObj['pageNumber'] = this.pageNumber;
        sidebarObj['pageSize'] = isExport ? this.totalMatches : this.pageSize;
        this.isLoader = isExport ? this.isLoader : true;
        this.filteredArray = isExport ? this.filteredArray : [];
        this.gridData = isExport ? this.gridData : [];
        if (this.shelfPermissionIA != 'all') {
            sidebarObj['productId'] = [...new Set([...sidebarObj['productId'], ...this.userShelfProductIds])];
        }
        if (this.showApprovedProductsOnly || this.shelfPermissionIA == 'shelf') {
            sidebarObj['productId'] = this.approvedProductIds;
        }
        this.benefitCalculatorService.postProductsDetails(sidebarObj).pipe(take(1)).subscribe((res: any) => {
            this.isLoader = false;
            if (isExport) {
                this.exportToExcel(res.productRiders);
            } else {
                this.setProductList(res);
            }
        }, (error) => {
            this.getFilterSideBar();
            //this.isLoader = false;
            //this.messageService.add({ key: 'tc', severity: 'error', summary: 'Error', detail: 'Something went wrong, please try sometime' });
        });
    }

    getFilterSideBarInit(sidebarObj1: any, fromRender: boolean = true, isExport: boolean = false) {
        let obj = JSON.parse(sidebarObj1);
        obj.sortBy = obj.sortBy ? obj.sortBy : 'WithdrawalAmount';
        //obj.joint = this.topbarForm.get('pouseage')?.value ? 'Yes' : 'No';
        obj.joint = this.ownerType.toLowerCase() == 'joint' ? 'Yes' : 'No';
        if (this.ownerType.toLowerCase() == 'joint') {
            obj.ageBand = this.spouseagecheck > this.agecheck ? this.agecheck : this.spouseagecheck;
        } else {
            obj.ageBand = this.agecheck;
        }
        obj.deferralYear = this.topbarForm.get('diffperiode')?.value ? this.topbarForm.get('diffperiode')?.value : this.diffperiodecheck;
        obj.gender = this.topbarForm.get('gender')?.value || '';
        obj.spageBand = this.ownerType.toLowerCase() == 'joint' ? this.topbarForm.get('pouseage')?.value || 55 : 0;
        obj.benefitBaseType = this.topbarForm.get('ridertype')?.value || 'All';
        obj.stateCode = this.topbarForm.get('illinois')?.value || 'ALL';
        let basicFilterObj: any = this.getBasicFilterObj()
        sessionStorage.setItem("basicFilterObj", JSON.stringify(basicFilterObj));
        if (!this.selectedStateName && obj.stateCode) {
            const state = this.stateData.find(x => x.stateCode == obj.stateCode);
            if (state) {
                this.selectedStateName = state.stateName;
            }
        }
        if (fromRender) {
            obj.approvedProductsOnly = obj.approvedProductsOnly ?? this.showApprovedProductsOnly;
        } else {
            obj.approvedProductsOnly = this.showApprovedProductsOnly;
        }
        this.showApprovedProductsOnly = obj.approvedProductsOnly;
        sessionStorage.setItem("sidebarObject", JSON.stringify(obj));
        this.filterdataobj_group = obj.groupId != null ? obj.groupId : [];
        this.filterdataobj_products = obj.productId != null ? obj.productId : [];
        this.SelectFilter_AMbest = obj.amBestRating != null ? obj.amBestRating : [];
        this.filterdataobj_surrender_year = obj.surrYear != null ? obj.surrYear : [];
        this.filterdataobj_riderfee = obj.riderFee != null ? obj.groupId : null;
        this.filterdataobj_strategyfee = obj.strategyFee != null ? obj.groupId : null;
        obj['pageNumber'] = this.pageNumber;
        obj['pageSize'] = isExport ? this.totalMatches : this.pageSize;
        this.isLoader = isExport ? this.isLoader : true;
        this.filteredArray = isExport ? this.filteredArray : this.pageNumber == 1 ? [] : this.filteredArray;
        this.gridData = isExport ? this.gridData : this.pageNumber == 1 ? [] : this.gridData;
        let productIds: number[] = [];
        if (!obj['productId']) {
            obj['productId'] = [];
        }
        if (this.shelfPermissionIA != 'all') {
            productIds = this.userShelfProductIds;
        }
        if (this.showApprovedProductsOnly || this.shelfPermissionIA == 'shelf') {
            productIds = this.approvedProductIds;
        }
        if (this.filterdataobj_products.length > 0) {
            obj['productId'] = this.filterdataobj_products.filter((value: number) => productIds.length > 0 ? productIds.indexOf(value) > -1 : true);
        }
        const selectedShelfName = sessionStorage.getItem('CustomShelfName');
        if (selectedShelfName) {
            this.isAdvanceFilterChanged = true;
            let customShelfProducts = this.userCustomShelfs.find(x => x.shelfName == selectedShelfName).items.map((x: any) => x.productId);
            if (customShelfProducts.length > 0) {
                obj['productId'] = [...obj['productId'], ...customShelfProducts];
            }
        }
        if (obj['productId'].length == 0) {
            obj['productId'] = productIds;
        } else {
            obj['productId'] = obj['productId'].filter((value: number) => productIds.length > 0 ? productIds.indexOf(value) > -1 : true);
        }

        if (isExport || this.filteredArray.length == 0 || this.pageNumber != 1) {
            this.getProductRiders(obj, isExport);
        }
    }

    onExport() {
        this.paginateIllustration = false;
        this.isLoad = true;
        setTimeout(() => {
            html2canvas(this.exportPdf.nativeElement, { useCORS: true, scale: 2 }).then((successRef: any) => {
                const imgWidth = 208;
                const pageHeight = 295;
                const imgHeight = (successRef.height * imgWidth) / successRef.width;
                let heightLeft = imgHeight;
                let position = 0;
                heightLeft -= pageHeight;
                const doc = new jsPDF('p', 'mm', 'a4');
                doc.addImage(successRef, 'PNG', 0, position, imgWidth, imgHeight, '', 'FAST');
                while (heightLeft >= 0) {
                    position = heightLeft - imgHeight;
                    doc.addPage();
                    doc.addImage(successRef, 'PNG', 0, position, imgWidth, imgHeight, '', 'FAST');
                    heightLeft -= pageHeight;
                }
                return doc;
            })
                .then((doc: any) => {
                    doc.save(`Illustration_${Date.now()}.pdf`);
                    this.isLoad = false;
                    this.paginateIllustration = true;
                });
        }, 500);

    }

    onCompare(event: any) {
        if(this.totalCompare >= 2){
            this.onCompareDatachange(this.compareData)
        }else{
            this.totalCompare = 0;
            this.isCompare = event.checked;
            this.compareData = [];
            this.filteredArray.map((data: any) => {
                if (data.isChecked == true) {
                    data.isChecked = false;
                }
            })
        }
    }

    onCompareChange(product: any, e: any) {
        // Handle removal of existing item
        const MAX_COMPARE_ITEMS = 3;
        const productId = product.id;
        const arrayIndex = product.arrayIndex;
        // Find indices for different operations
        const compareIndex = this.compareData.findIndex((x: any) => x.arrayIndex === arrayIndex);
        //  const counterIndex = this.filteredArray.findIndex((x: any) => x.id === productId);
        const counterIndex = this.filteredArray.findIndex((x: any) => x.arrayIndex === arrayIndex);
        if (compareIndex > -1) {
            this.removeFromCompare(compareIndex, counterIndex);
        } else {
            // Handle addition of new item
            if (this.totalCompare < MAX_COMPARE_ITEMS) {
                this.addToCompare(product, counterIndex);
            }else{
                this.handleMaxCompareLimit(product, e);
            }
        }
        // Update state and UI
        this.updateCompareState();
    }

    private removeFromCompare(compareIndex: number, counterIndex: number): void {
        this.compareData.splice(compareIndex, 1);
        if (counterIndex > -1) {
            this.filteredArray[counterIndex].isChecked = false;
        }
        this.totalCompare = this.compareData.length;
    }

    private addToCompare(product: any, counterIndex?: number): void {
        if (counterIndex !== undefined) {
            this.filteredArray[counterIndex].isChecked = true;
        }
        this.setCompareData(product);
        this.totalCompare = this.compareData.length;
    }

    private handleMaxCompareLimit(product: any, e: any): void {
        const compareTimeout = setTimeout(() => {
            const element = document.querySelector(`#checkbox_${product.arrayIndex} span.p-checkbox-icon`);
            if (element) {
                element.classList.remove('pi-check');
            }
            product.isChecked = false;
            e.originalEvent?.preventDefault();
            e.originalEvent?.stopPropagation();
            this.showErrorMessage('You can compare maximum 3 products');
            clearTimeout(compareTimeout);
        });
    }

    private updateCompareState(): void {
        this.totalCompare = this.compareData.length;
        this.isCompare = this.totalCompare > 0;

        if (!this.isCompare) {
            this.checked = false;
        }

        if (this.totalCompare > 0) {
            this.resizeSearchResultDiv();
        }
    }

    private showErrorMessage(message: string): void {
        this.messageService.add({
            key: 'tc',
            severity: 'error',
            summary: 'Error',
            detail: message
        });
    }

    setCompareData(product: any) {
        for (const data of this.filteredArray) {
            if (Number(product.arrayIndex) === data.arrayIndex && Number(product.withdrawalPer) === data.withdrawalPer) {
                let rollUpdata = [];
                if (this.topbarForm.get('pouseage')?.value != 0) {
                    if (data.rollupPerJoint != null && data.rollupPerJoint != '') {
                        const rollUpPerArray = data.rollupPerJoint.split(',');
                        const rollupYearsArray = data.maxRollupYears.split(',');
                        const rollupIsSimpleCompArray = data.rollupIsSimpleComp.split(',');
                        for (let index = 0; index < rollUpPerArray.length; index++) {
                            let rollUpText: any = rollUpPerArray[index] + '% ' + rollupIsSimpleCompArray[index] + ' / Years ' + rollupYearsArray[index];
                            rollUpdata.push(rollUpText);
                        }
                    }
                } else {
                    if (data.rollupPer != null && data.rollupPer != '') {
                        const rollUpPerArray = data.rollupPer.split(',');
                        const rollupYearsArray = data.maxRollupYears.split(',');
                        const rollupIsSimpleCompArray = data.rollupIsSimpleComp.split(',');
                        for (let index = 0; index < rollUpPerArray.length; index++) {
                            let rollUpText: any = rollUpPerArray[index] + '% ' + rollupIsSimpleCompArray[index] + ' / Years ' + rollupYearsArray[index];
                            rollUpdata.push(rollUpText);
                        }
                    }
                }
                let rollupsimplecomp = '';
                let riderAge = '';
                if ((this.agecheck > 0 && this.spouseagecheck == 0) || (this.agecheck == 0 && this.spouseagecheck > 0)) {
                    riderAge = this.agecheck > 0 ? this.agecheck.toString() : this.spouseagecheck.toString();
                } else if (this.agecheck > 0 && this.spouseagecheck > 0) {
                    riderAge = `Age ${this.agecheck} / Spouse Age ${this.spouseagecheck}`;
                }
                this.compareData.push(
                    {
                        logo1: data.logo1,
                        logo2: data.logo2,
                        gmwbId: data.gmwbId,
                        arrayIndex: data.arrayIndex,
                        withdrawalFrequency: this.withdrawalFrequency,
                        initialBenifit: this.initialBenifit,
                        productid: data.productid,
                        productName: data.productName,
                        companyid: data.companyid,
                        companyName: data.companyName,
                        riderName: data.riderName,
                        riderAge: riderAge, //`Min. Age ${data.minAge} / Max. Age ${data.maxAge}`,
                        riderFeeBasis: data.riderFee + ' ' + 'of' + ' ' + 'Benefit Base',
                        singleJoinIncomeData:  this.ownerType.toLowerCase() === 'joint' ? 'Joint' : 'Single',
                        singleJointAge: this.topbarForm.get('pouseage')?.value == 0 ? this.topbarForm.get('age')?.value : (this.topbarForm.get('age')?.value + '/' + this.topbarForm.get('pouseage')?.value),
                        purchasePayment: this.topbarForm.get('amount')?.value || 100000,
                        initialBenifitdata: ((this.topbarForm.get('amount')?.value || 100000) + (((this.topbarForm.get('amount')?.value || 100000) * data.bbBonus) / 100) + (((this.topbarForm.get('amount')?.value || 100000) * data.premiumBonus) / 100)),
                        annualIncome: '$' + this.getAnnualIncome(data).toLocaleString('en'),
                        initialBenefitBase:  this.topbarForm.get('Contribution')?.value === 'income' ? this.getAnnualIncome(data, true) : this.getInitialBenefitBase(data),
                        deffralPer: this.topbarForm.get('diffperiode')?.value,
                        //   annualIncome: '$' + this.getAnnualIncome(data).toLocaleString('en') + ' ' + (this.topbarForm.get('periode')?.value ? 'Annually' : 'Monthly'),
                        rolldata: data.rollUpdata,
                        minAge: data.minAge,
                        maxAge: data.maxAge,
                        riderFee: data.riderFee,
                        rollupPer: data.rollupPer,
                        withdrawalPer: this.topbarForm.get('pouseage')?.value && this.topbarForm.get('pouseage')?.value != 0 ? data.withdrawalPerJoint : data.withdrawalPer, //data.withdrawalPer,
                        riderFeeJoint: data.riderFeeJoint,
                        rollupPerJoint: data.rollupPerJoint,
                        withdrawalPerJoint: data.withdrawalPerJoint,
                        maxRollupYears: data.rollupYears,
                        rollupYears: data.rollupYears,
                        isCaseAOrC: data.isCaseAOrC,
                        ageBand1: data.ageBand1,
                        ageBand2: data.ageBand2,
                        purchasePayBonus: data.purchasePayBonus,
                        internalName: data.internalName,
                        bonusPercentage: data.bonusPercentage,
                        bonusName: data.bonusName,
                        factorSingle: data.factorSingle,
                        factorJoint: data.factorJoint,
                        premiumBonus: data.premiumBonus,
                        bonusPercentageBasis: data.bonusPercentageBasis,
                        id: data.id,
                        otherVariable: data.otherVariable,
                        benifitBaseType: data.benifitBaseType,
                        bbBonus: data.bbBonus,
                        groupId: data.groupId,
                        groupName: data.groupName,
                        bestid: data.bestid,
                        surryr: data.surryr,
                        strategyFee: data.strategyFee,
                        gender: data.gender,
                        bonusCaseId: data.bonusCaseId,
                        bonusCaseName: data.bonusCaseName,
                        availStateException: data.availStateException ? data.availStateException : "",
                        exceptions: data.exceptions,
                        rollupIsSimpleComp: data.rollupIsSimpleComp,
                        riderFeedata: data.riderFee, //(this.topbarForm.get('pouseage')?.value && this.topbarForm.get('pouseage')?.value != 0 ? data.riderFeeJoint : data.riderFee) ,
                        chargeBasisName: data.chargeBasisName,
                        highAnnivValStepup: data.highAnnivValStepup,
                        IncomePeriod: this.topbarForm.get('pouseage')?.value && this.topbarForm.get('Contribution')?.value == 'contribution' ? (this.topbarForm.get('periode')?.value ? 'Est. Annual Inc.' : 'Est. Monthly Inc.') : 'Est. Initial Contrib.', //(this.topbarForm.get('periode')?.value ? 'Annually' : 'Monthly'),
                        rollUp: this.topbarForm.get('pouseage')?.value && this.topbarForm.get('pouseage')?.value != 0 ? data.rollupPerJoint : data.rollupPer,
                        withdrawal: this.ownerType.toLowerCase() === 'joint' ? data.withdrawalPerJoint : data.withdrawalPer,
                        gmwbAvailStateExceptions: data.gmwbAvailStateExceptions,
                        isChecked: true,
                        waitingTerm: data.waitingTerm,
                        waitingPeriod: data.waitingPeriod ? parseInt(data.waitingPeriod) : 0,
                        chargeFreqDeductedWhen: data.chargeFreqDeductedWhen,
                        marketingName: data.marketingName,
                        isShelfProduct: this.approvedProductIds.indexOf(data.productid) > -1, //this.userShelfProductIds.indexOf(data.productid) > -1
                        isGmwbBonusBenefitBase: data.isGmwbBonusBenefitBase,
                        isBonusBenefitBase: data.isBonusBenefitBase,
                        isGmwbBonusAccountValue: data.isGmwbBonusAccountValue,
                        isBonusAccountValue: data.isBonusAccountValue
                    }
                )
            }
        }
    }

    onComparebtnchange(event: any, e: any) {
        this.compareData = []
        this.checked = true;
        if (this.isCompare === false) {
            this.isSwitch = true
            this.isCompare = true;
            // this.totalCompare = 1
        }
        if (this.compareData.length < 2) {
            this.rollupdata = [];
            let test = this.filteredArray.find((x: any) => x.id == event.id)
            if (test) {
                test.isChecked = true;
            }
            const basicFilterObj: any = sessionStorage.getItem('basicFilterObj');
            let amountType = 'contribution';
            if (basicFilterObj) {
                amountType = JSON.parse(basicFilterObj).amountType;
            }
            this.filteredArray.map((data: any) => {
                if (Number(event.id) === data.id && Number(event.withdrawalPer) === data.withdrawalPer) {
                    let riderAge = '';
                    if ((this.agecheck > 0 && this.spouseagecheck == 0) || (this.agecheck == 0 && this.spouseagecheck > 0)) {
                        riderAge = this.agecheck > 0 ? this.agecheck.toString() : this.spouseagecheck.toString();
                    } else if (this.agecheck > 0 && this.spouseagecheck > 0) {
                        riderAge = `Age ${this.agecheck} / Spouse Age ${this.spouseagecheck}`;
                    }

                   
                    this.compareData.push(
                        {
                            logo1: data.logo1,
                            logo2: data.logo2,
                            gmwbId: data.gmwbId,
                            withdrawalFrequency: this.withdrawalFrequency,
                            initialBenifit: this.initialBenifit,
                            productid: data.productid,
                            productName: data.productName,
                            companyid: data.companyid,
                            companyName: data.companyName,
                            riderName: data.riderName,
                            riderAge: riderAge, //`Min. Age ${data.minAge} / Max. Age ${data.maxAge}`,
                            riderFeeBasis: data.riderFee + ' ' + 'of' + ' ' + 'Benefit Base',
                            singleJoinIncomeData: this.topbarForm.get('pouseage')?.value != 0 ? 'Joint' : 'Single',
                            singleJointAge: this.topbarForm.get('pouseage')?.value == 0 ? this.topbarForm.get('age')?.value : (this.topbarForm.get('age')?.value + '/' + this.topbarForm.get('pouseage')?.value),
                            purchasePayment: this.topbarForm.get('amount')?.value || 100000,
                            initialBenifitdata: ((this.topbarForm.get('amount')?.value || 100000) + (((this.topbarForm.get('amount')?.value || 100000) * data.bbBonus) / 100) + (((this.topbarForm.get('amount')?.value || 100000) * data.premiumBonus) / 100)),
                           
                            deffralPer: this.topbarForm.get('diffperiode')?.value,
                            //annualIncome: '$' + this.getAnnualIncome(data).toLocaleString('en') + ' ' + (this.topbarForm.get('periode')?.value ? 'Annually' : 'Monthly'),
                            annualIncome: '$' + this.getAnnualIncome(data).toLocaleString('en'),
                            initialBenefitBase:  this.topbarForm.get('Contribution')?.value === 'income' ? this.getAnnualIncome(data, true) : this.getInitialBenefitBase(data),
                            minAge: data.minAge,
                            maxAge: data.maxAge,
                            riderFee: data.riderFee,
                            rollupPer: data.rollupPer,
                            withdrawalPer: this.topbarForm.get('pouseage')?.value && this.topbarForm.get('pouseage')?.value != 0 ? data.withdrawalPerJoint : data.withdrawalPer, //data.withdrawalPer,
                            riderFeeJoint: data.riderFeeJoint,
                            rollupPerJoint: data.rollupPerJoint,
                            withdrawalPerJoint: data.withdrawalPerJoint,
                            maxRollupYears: data.rollupYears,
                            rollupYears: data.rollupYears,
                            isCaseAOrC: data.isCaseAOrC,
                            ageBand1: data.ageBand1,
                            ageBand2: data.ageBand2,
                            purchasePayBonus: data.purchasePayBonus,
                            internalName: data.internalName,
                            bonusPercentage: data.bonusPercentage,
                            bonusName: data.bonusName,
                            factorSingle: data.factorSingle,
                            factorJoint: data.factorJoint,
                            premiumBonus: data.premiumBonus,
                            bonusPercentageBasis: data.bonusPercentageBasis,
                            id: data.id,
                            otherVariable: data.otherVariable,
                            benifitBaseType: data.benifitBaseType,
                            bbBonus: data.bbBonus,
                            groupId: data.groupId,
                            groupName: data.groupName,
                            bestid: data.bestid,
                            surryr: data.surryr,
                            strategyFee: data.strategyFee,
                            gender: data.gender,
                            bonusCaseId: data.bonusCaseId,
                            bonusCaseName: data.bonusCaseName,
                            availStateException: data.availStateException ? data.availStateException : "",
                            exceptions: data.exceptions,
                            rollupIsSimpleComp: data.rollupIsSimpleComp,
                            riderFeedata: data.riderFee, //(this.topbarForm.get('pouseage')?.value && this.topbarForm.get('pouseage')?.value != 0 ? data.riderFeeJoint : data.riderFee) ,
                            chargeBasisName: data.chargeBasisName,
                            highAnnivValStepup: data.highAnnivValStepup,
                            IncomePeriod: this.topbarForm.get('pouseage')?.value && this.topbarForm.get('Contribution')?.value == 'contribution' ? (this.topbarForm.get('periode')?.value ? 'Est. Annual Inc.' : 'Est. Monthly Inc.') : 'Est. Initial Contrib.', //(this.topbarForm.get('periode')?.value ? 'Annually' : 'Monthly'),
                            rollUp: this.topbarForm.get('pouseage')?.value && this.topbarForm.get('pouseage')?.value != 0 ? data.rollupPerJoint : data.rollupPer,
                            withdrawal: this.ownerType.toLowerCase() === 'joint' ? data.withdrawalPerJoint : data.withdrawalPer,
                            gmwbAvailStateExceptions: data.gmwbAvailStateExceptions,
                            isChecked: true,
                            waitingTerm: data.waitingTerm,
                            waitingPeriod: data.waitingPeriod ? parseInt(data.waitingPeriod) : 0,
                            chargeFreqDeductedWhen: data.chargeFreqDeductedWhen,
                            marketingName: data.marketingName,
                            isShelfProduct: this.approvedProductIds.indexOf(data.productid) > -1//this.userShelfProductIds.indexOf(data.productid) > -1
                        }
                    )

                }
            })
        } 
    }
    
    onCompChipRemove(compdata: any) {
        let test = this.filteredArray.find((x: any) => x.id == compdata.id)
        if (test) {
            test.isChecked = false;
        }
        let index: number = 0;
        index = this.compareData.findIndex((e: any) => e.id === compdata.id);
        this.compareData.splice(index, 1);
        compdata.isChecked = false;
        this.compDataChk = false;
        this.totalCompare = this.totalCompare - 1;
        if (this.totalCompare == 0) {
            this.isCompare = false;
            this.checked = false;
        }
    }
    onCompareDatachange(val: any) {
        if (this.compareData.length >= 2) {
            this.compareCardsData = val;
            let productsId: any = this.compareData.map(x => x.productid);
            productsId = [...new Set(productsId)].toString();
            this.totalCompare = this.compareData.length;
            this.checked = true;
            this.isClickedOnCompare = true;
            this.router.navigateByUrl(`/indexed-product-compare?products=${productsId}`);
        }
    }
    clearCompareChange() {
        this.isCompare = false;
        this.totalCompare = 0;
        this.checked = false;
        this.compareData = [];
        this.filteredArray.map((data: any) => {
            if (data.isChecked == true) {
                data.isChecked = false;
            }
        })
    }
    onLogout() {
        sessionStorage.clear();
        this.router.navigate(['/auth/login']);
    }
    saveContinue() {
        this.saveSeavch = true;
    }
    saveedSearches() {
        this.router.navigate(['/savedsearch'])
    }
    saveSearch() {
        this.saveFormSubmitted = true;
        if (this.searchDataForm.valid) {
            let SelectFilter_AMbest = [];
            let surrYearIds = [];
            let groupIds = [];
            let productIds = [];
            let riderFeeId = [];
            let strategyFeeId = [];

            if (this.filterdataobj_group != undefined) {
                for (let i = 0; i < this.filterdataobj_group.length; i++) {
                    if (this.filterdataobj_group[i]) {
                        groupIds.push(this.filterdataobj_group[i]);
                    }
                }
            }
            if (this.filterdataobj_products != undefined) {
                for (let i = 0; i < this.filterdataobj_products.length; i++) {
                    if (this.filterdataobj_products[i]) {
                        productIds.push(this.filterdataobj_products[i]);
                    }

                }
            }
            if (this.SelectFilter_AMbest != undefined) {
                for (let i = 0; i < this.SelectFilter_AMbest.length; i++) {
                    if (this.SelectFilter_AMbest[i]) {
                        SelectFilter_AMbest.push(this.SelectFilter_AMbest[i]);
                    }
                }
            }
            if (this.filterdataobj_surrender_year != undefined) {
                for (let i = 0; i < this.filterdataobj_surrender_year.length; i++) {
                    if (this.filterdataobj_surrender_year[i]) {
                        surrYearIds.push(this.filterdataobj_surrender_year[i]);
                    }
                }
            }
            if (this.filterdataobj_riderfee != undefined) {
                if (this.filterdataobj_riderfee[0]) {
                    riderFeeId.push(this.filterdataobj_riderfee[0]);
                }
            }
            if (this.filterdataobj_strategyfee != undefined) {
                if (this.filterdataobj_strategyfee[0]) {
                    strategyFeeId.push(this.filterdataobj_strategyfee[0]);
                }
            }

            let chipobj = {
                filled: true,
                filterdataobj_group_name: this.filterdataobj_group_name,
                filterdataobj_groupid: groupIds,

                SelectFilter_AMbest_name: this.SelectFilter_AMbest_name,
                SelectFilter_AMbestid: SelectFilter_AMbest,

                filterdataobj_surrender_year_name: this.filterdataobj_surrender_year_name,
                filterdataobj_surrender_yearid: surrYearIds,

                filterdataobj_products_name: this.filterdataobj_products_name,
                filterdataobj_productsid: productIds,

                filterdataobj_strategyfee_name: this.filterdataobj_strategyfee_name,
                filterdataobj_strategyfeeid: strategyFeeId,

                filterdataobj_riderfee_name: this.filterdataobj_riderfee_name,
                filterdataobj_riderfeeid: riderFeeId,

                gender: this.topbarForm.get('gender')?.value,
                age: this.topbarForm.get('age')?.value,
                pouseage: this.topbarForm.get('pouseage')?.value,
                state: this.topbarForm.get('illinois')?.value,
                Contribution: this.topbarForm.get('Contribution')?.value,
                income: this.topbarForm.get('income')?.value,
                amount: this.topbarForm.get('amount')?.value,
                periode: this.topbarForm.get('periode')?.value,
                diffperiode: this.topbarForm.get('diffperiode')?.value,
                searchtitle: this.searchDataForm.value.searchtitle
            }
            let savedsearchdata = JSON.stringify(chipobj);
            let uID = this.benefitCalculatorService.decryptUsingAES256(JSON.parse(sessionStorage.getItem('userId') || ''));
            let savedsearchobj = {
                // id: ,
                userId: JSON.parse(uID),
                searchString: savedsearchdata,
                lastUpdatedDate: this.illEffectDate
            }

            //save serach insert
            this.benefitCalculatorService.postSaveSearch(savedsearchobj).pipe(take(1)).subscribe((res: any) => {

            },
                err => {

                })
            // this.set('saveSearch', chipobj)
            this.messageService.add({ key: 'tc', severity: 'success', summary: 'success', detail: 'Search history has been saved Successfully !!' });
            this.saveSeavch = false;
            this.saveFormSubmitted = false;
            timer(2000).pipe(take(1)).subscribe(() => this.router.navigate(['/savedsearch']));
        }
    }
    updateContinue() {
        let SelectFilter_AMbest = [];
        let surrYearIds = [];
        let groupIds = [];
        let productIds = [];
        let riderFeeId = [];
        let strategyFeeId = [];

        for (let i = 0; i < this.filterdataobj_group.length; i++) {
            if (this.filterdataobj_group[i]) {
                groupIds.push(this.filterdataobj_group[i]);
            }
        }

        for (let i = 0; i < this.filterdataobj_products.length; i++) {
            if (this.filterdataobj_products[i]) {
                productIds.push(this.filterdataobj_products[i]);
            }
        }

        for (let i = 0; i < this.SelectFilter_AMbest.length; i++) {
            if (this.SelectFilter_AMbest[i]) {
                SelectFilter_AMbest.push(this.SelectFilter_AMbest[i]);
            }
        }

        for (let i = 0; i < this.filterdataobj_surrender_year.length; i++) {
            if (this.filterdataobj_surrender_year[i]) {
                surrYearIds.push(this.filterdataobj_surrender_year[i]);
            }
        }

        if (this.filterdataobj_riderfee[0]) {
            riderFeeId.push(this.filterdataobj_riderfee[0]);
        }

        if (this.filterdataobj_strategyfee[0]) {
            strategyFeeId.push(this.filterdataobj_strategyfee[0]);
        }


        let chipobj = {
            filled: true,
            filterdataobj_group_name: this.filterdataobj_group_name,
            filterdataobj_groupid: groupIds,

            SelectFilter_AMbest_name: this.SelectFilter_AMbest_name,
            SelectFilter_AMbestid: SelectFilter_AMbest,

            filterdataobj_surrender_year_name: this.filterdataobj_surrender_year_name,
            filterdataobj_surrender_yearid: surrYearIds,

            filterdataobj_products_name: this.filterdataobj_products_name,
            filterdataobj_productsid: productIds,

            filterdataobj_strategyfee_name: this.filterdataobj_strategyfee_name,
            filterdataobj_strategyfeeid: strategyFeeId,

            filterdataobj_riderfee_name: this.filterdataobj_riderfee_name,
            filterdataobj_riderfeeid: riderFeeId,

            gender: this.topbarForm.get('gender')?.value,
            age: this.topbarForm.get('age')?.value,
            pouseage: this.topbarForm.get('pouseage')?.value,
            state: this.topbarForm.get('illinois')?.value,
            Contribution: this.topbarForm.get('Contribution')?.value,
            income: this.topbarForm.get('income')?.value,
            amount: this.topbarForm.get('amount')?.value,
            periode: this.topbarForm.get('periode')?.value,
            diffperiode: this.topbarForm.get('diffperiode')?.value,
        }
        let savedsearchdata = JSON.stringify(chipobj);

        let savedsearchobj = {
            id: this.filterEdit.source._value[0].id,
            userId: this.filterEdit.source._value[0].userId,
            searchString: savedsearchdata,
            lastUpdatedDate: this.illEffectDate
        }
        //save serach insert
        this.benefitCalculatorService.putSaveSearch(savedsearchobj).pipe(take(1)).subscribe((res: any) => {
        },
            err => {

            })
        // this.set('saveSearch', chipobj)
        this.messageService.add({ key: 'tc', severity: 'success', summary: 'success', detail: 'Update history Successfully !!' });
        this.saveSeavch = false;
        this.router.navigate(['/savedsearch']);
        let viewdata = [''];
        this.benefitCalculatorService.setsavedData(viewdata);
    }
    set(key: string, value: any): void {
        sessionStorage.setItem(key, JSON.stringify(value));
    }
    remove(key: string): void {
        sessionStorage.removeItem(key);
    }
    saveCancel() {
        this.saveSeavch = false;
    }

    cancelCustomsearch() {
        this.createShelfPopup = false
        if (this.IsCustomShelf) {
            this.IsCustomShelf = !this.IsCustomShelf
        }
    }
    sidebarOpen() {
        this.sideMenuShow = !this.sideMenuShow
    }
    onAddchip(e: any) {
    }
    closeIllustration() {
        this.illustration = false;
    }
    closeProductProfile() {
        this.productProfile = false;
    }
    getAllProducsAndCustomShelf() {
        this.benefitCalculatorService.getProducsCustomShelf().pipe(take(1)).subscribe((res: any) => {
            this.customProductList = res ? res : [];
            let mainArray: any = [];
            let datalist = res;
            let companyid = [];
            for (let i = 0; i < datalist.length; i++) {
                const objcompany = {
                    companyid: datalist[i].companyid,
                    companyname: datalist[i].companyName,
                };
                companyid.push(objcompany);
            }
            let unique = [
                ...new Map(
                    companyid.map((companyid) => [
                        companyid['companyid'],
                        companyid,
                    ])
                ).values(),
            ];
            unique = unique.sort(function (objdata, objdatatwo) {
                if (objdata.companyname < objdatatwo.companyname) {
                    return -1;
                } else if (objdata.companyname > objdatatwo.companyname) {
                    return 1;
                } else {
                    return 0;
                }
            });

            for (let i = 0; i < unique.length; i++) {
                const objdatalist = datalist.filter(
                    (x: any) => x.companyid === unique[i].companyid
                );
                let childrens = [];
                for (let j = 0; j < objdatalist.length; j++) {
                    let addProduct = true;
                    if (this.loginUserData.shelfPermissionIA == 'shelf') {
                        addProduct = this.approvedProductIds.indexOf(objdatalist[j].productid) > -1;
                    }
                    if (addProduct) {
                        childrens.push({
                            key: objdatalist[j].productid,
                            label: (objdatalist[j].name).trim() + ' ' + '(' + objdatalist[j].totalProducts + ')',
                            data: (objdatalist[j].name).trim(),
                            total: objdatalist[j].total,
                            type: 'product',
                            isShelfProduct: this.approvedProductIds.indexOf(objdatalist[j].productid) > -1 //this.userShelfProductIds.indexOf(objdatalist[j].productid) > -1
                        });
                    }
                }
                childrens = childrens.sort((a, b) => {
                    const companyComparison = a.label.localeCompare(b.label);
                    if (companyComparison !== 0) {
                        return companyComparison;
                    }
                    return a.label.localeCompare(b.label);
                });
                mainArray.push({
                    children: childrens,
                    data: unique[i].companyname,
                    key: unique[i].companyid,
                    label: unique[i].companyname,
                    hasShelfProduct: childrens.some((x: any) => x.isShelfProduct)
                });
                if (this.loginUserData.shelfPermissionIA == 'shelf') {
                    mainArray = mainArray.filter((item: any) => {
                        item.children = item.children.filter((child: any) => child.isShelfProduct);
                        return item.children.length > 0;
                    });
                }
                mainArray = mainArray.sort((a: any, b: any) => {
                    const companyComparison = a.label.localeCompare(b.label);
                    if (companyComparison !== 0) {
                        return companyComparison;
                    }
                    return a.label.localeCompare(b.label);
                });
            }
            this.customShelfMasterData = JSON.parse(JSON.stringify(mainArray));
        }, (error: any) => {
            this.messageService.add({ key: 'tc', severity: 'error', summary: 'Error', detail: 'Failed to load product shelf data' });
        });
        this.benefitCalculatorService.getUserCustomShelfs(this.loginUserData.id).pipe(take(1)).subscribe((res: any) => {
            if (res.data.length > 0) {
                this.custoShelfShow = true;
                for (let item of res.data) {
                    item.shelfName = item.shelfName ? item.shelfName : 'Custom Shelf';
                    const index = this.userCustomShelfs.findIndex((x: any) => x.shelfName == item.shelfName);
                    if (index > -1) {
                        this.userCustomShelfs[index].items.push(item);
                        if (!this.userCustomShelfs[index].allCompanies.includes(item.companyid)) {
                            this.userCustomShelfs[index].allCompanies.push(item.companyid);
                        }
                    } else {
                        this.userCustomShelfs.push({
                            shelfName: item.shelfName ? item.shelfName : 'Custom Shelf',
                            items: [item],
                            allCompanies: [item.companyid]
                        })
                    }
                }
                this.userCustomShelfs.unshift({ shelfName: 'Select', items: [] });
            }
        }, (error: any) => {
            this.messageService.add({ key: 'tc', severity: 'error', summary: 'Error', detail: 'Failed to load custom shelves' });
        });
    }

    applyCustomShelf(customShelfProducts = []) {
        this.onCustomShelf(customShelfProducts);
    }

    onCustomShelf(customShelfProducts: any) {
        this.filterCustomself = [];
        this.filteredCustomshelfs = [];
        this.customProductList.forEach((customProduct: any) => {
            customShelfProducts.forEach((resProduct: any) => {
                if (customProduct.productid === resProduct.productId) {
                    this.filterCustomself.push({
                        productid: customProduct.productid,
                    });
                }
            });
        });
        this.filterCustomself.forEach((filteredProduct: any) => {
            this.filteredCustomshelfs.push(filteredProduct.productid);
        });
        if (this.filteredCustomshelfs.length > 0) {
            this.filtredCustomSelfObj = JSON.parse(JSON.stringify(this.filterdataobj_products));
            if (this.filtredCustomSelfObj && this.filtredCustomSelfObj.length > 0) {
                this.filterdataobj_products = [...new Set([...this.filtredCustomSelfObj, ...this.filteredCustomshelfs])];
            } else {
                this.filterdataobj_products = JSON.parse(JSON.stringify(this.filteredCustomshelfs));
            }
            this.resetDataViewItems();
            this.getFilterSideBar();
        } else {
            const sidebarObject = sessionStorage.getItem('sidebarObject');
            if (sidebarObject) {
                const sidebarData = JSON.parse(sidebarObject);
                sidebarData.productId = this.filtredCustomSelfObj;
                this.resetDataViewItems();
                this.getFilterSideBarInit(JSON.stringify(sidebarData));
            }
        }
    }

    resetDataViewItems() {
        this.isLoader = true;
        this.gridData = [];
        this.filteredArray = [];
        this.compareData = [];
        this.isCompare = false;
        this.totalCompare = 0;
        this.checked = false;
    }

    onApprovedProducts(event: any) {
        this.resetDataViewItems();
        // this.isFilterChanged = true;
        let sidebarObject: any = (sessionStorage.getItem('sidebarObject'));
        if (sidebarObject) {
            this.pageNumber = 1;
            this.getFilterSideBarInit(sidebarObject, false);
        } else {
            this.getFilterSideBar();
        }
    }

    createCustomNew() {
        this.router.navigate(['/customshelf'])
    }

    get searchDataFormControls(): any {
        return this.searchDataForm['controls'];
    }

    public noWhitespaceValidator(control: FormControl) {
        return (control.value || '').trim().length ? null : { 'whitespace': true };
    }


    onScroll(event: any) {
        const element = event.target;
        const threshold = 20; // Adjust the threshold as needed
        if (element.scrollHeight - element.scrollTop <= element.clientHeight + threshold && !this.isLoader &&
            this.filteredArray.length < this.totalMatches) {
                this.loadMoreProductRiders();
        }
    }

    loadMoreProductRiders() {
        this.pageNumber = this.pageNumber + 1;
        let sidebarObject: any = (sessionStorage.getItem('sidebarObject'));
        this.getFilterSideBarInit(sidebarObject, false);
    }

    setProductList(res: any) {
        const sidebarObject: any = (sessionStorage.getItem('sidebarObject'));
        const sidebarObj = JSON.parse(sidebarObject);
        if (res.productRiders.length > 0) {
            if (this.pageNumber == 1) {
                this.gridData = [];
                this.filteredArray = [];
            }
            if (this.showApprovedProductsOnly) {
                res.productRiders = res.productRiders.filter((product: any) => this.approvedProductIds.indexOf(product.productid) > -1);
            }
            const basicFilterObj: any = sessionStorage.getItem('basicFilterObj');
            let amountType =  'contribution';
            if (basicFilterObj) {
                amountType = JSON.parse(basicFilterObj).amountType;
            }
            const isContribution = amountType == 'contribution';
            let counter = 0;
            for (let data of res.productRiders) {
                const item = this.buildProductItem(data, (this.filteredArray.length) + counter, environment.domain);
                this.gridData.push(item);
                counter++;
            }
            this.utilityFunctionService.resultTime = this.utilityFunctionService.getESTDateTime();
        }
        this.filteredArray = JSON.parse(JSON.stringify(this.gridData));
        if (!this.benefitCalculatorService.resultSet) {
            const resultSet: any = {};
            this.benefitCalculatorService.resultSet = resultSet;
        }
        if (!sessionStorage.getItem('showAcknowledgement')) {
            this.showAcknowledgementDialog = true;
        }

        this.benefitCalculatorService.resultSet['productRiders'] = JSON.parse(JSON.stringify(this.gridData));
        this.benefitCalculatorService.resultSet['data'] = res;
        this.setSidebarData(res, sidebarObj);
    }

    setSidebarData(res: any, sidebarObj: any) {
        this.totalMatches = res.ridersCount;
        timer(1000).pipe(takeUntil(this.destroy$)).subscribe(() => this.scrollService.scrollToElementById('btn_load_more'));
        if (this.groupfilterFlag != "Groups") {
            this.groups = res.groups;
        }
        if (sidebarObj && sidebarObj.groupId.length == 0) {
            this.selectedGroups = [];
        } else {
            this.selectedGroups = res.groups;
        }
        let chipDataObject: any = sessionStorage.getItem('chipDataObject');
        if (this.productfilterFlag != "Product") {
            var mainArray: any = [];
            var datalist = res.products;
            var companyid = [];
            for (let i = 0; i < datalist.length; i++) {
                var objcompany = {
                    companyid: datalist[i].companyid,
                    companyname: datalist[i].companyName,
                };
                companyid.push(objcompany);

            }

            var unique = [
                ...new Map(
                    companyid.map((companyid) => [
                        companyid['companyid'],
                        companyid,
                    ])
                ).values(),
            ];
            unique = unique.sort((objdata: any, objdatatwo: any) => {
                if (objdata.companyname < objdatatwo.companyname) {
                    return -1;
                } else if (objdata.companyname > objdatatwo.companyname) {
                    return 1;
                } else {
                    return 0;
                }
            });
            const userShelfProductIds = this.loginUserData.userSelfProductListIndex.map((x: any) => x.productid);
            const approvedProductIds = this.loginUserData.userSelfProductListIndex_approved.map((x: any) => x.productid);
            for (let i = 0; i < unique.length; i++) {
                let objdatalist = datalist.filter(
                    (x: any) => x.companyid === unique[i].companyid
                );
                let childrens = [];
                for (let j = 0; j < objdatalist.length; j++) {
                    let addProduct = true;
                    if (this.loginUserData.shelfPermissionIA == 'shelf') {
                        addProduct = this.approvedProductIds.indexOf(objdatalist[j].productid) > -1;
                    }
                    if (addProduct) {
                        childrens.push({
                            key: objdatalist[j].productid,
                            label: (objdatalist[j].name).trim() + ' ' + '(' + objdatalist[j].totalProducts + ')',
                            data: (objdatalist[j].name).trim(),
                            total: objdatalist[j].total,
                            type: 'product',
                            isShelfProduct: this.approvedProductIds.indexOf(objdatalist[j].productid) > -1 //this.userShelfProductIds.indexOf(objdatalist[j].productid) > -1
                        });
                    }
                }
                childrens = childrens.sort((a, b) => {
                    const companyComparison = a.label.localeCompare(b.label);
                    if (companyComparison !== 0) {
                        return companyComparison;
                    }
                    return a.label.localeCompare(b.label);
                });
                mainArray.push({
                    children: childrens,
                    data: unique[i].companyname,
                    key: unique[i].companyid,
                    label: unique[i].companyname,
                    hasShelfProduct: childrens.some((x: any) => x.isShelfProduct)
                });
                if (this.loginUserData.shelfPermissionIA == 'shelf') {
                    mainArray = mainArray.filter((item: any) => {
                        item.children = item.children.filter((child: any) => child.isShelfProduct);
                        return item.children.length > 0;
                    });
                }
                mainArray = mainArray.sort((a: any, b: any) => {
                    const companyComparison = a.label.localeCompare(b.label);
                    if (companyComparison !== 0) {
                        return companyComparison;
                    }
                    return a.label.localeCompare(b.label);
                });
            }
            this.benefitCalculatorService.allProducts = JSON.parse(JSON.stringify(mainArray));
            if (!this.sideMenuShow) {
                if (!sessionStorage.getItem('allProducts')) {
                    sessionStorage.setItem('allProducts', JSON.stringify(mainArray));
                    this.productList = JSON.parse(JSON.stringify(mainArray));
                } else {
                    let allProducts: any = sessionStorage.getItem('allProducts')
                    if (allProducts) {
                        allProducts = JSON.parse(allProducts);
                        this.productList = allProducts;
                        this.selectedProducts = [];
                        if (chipDataObject) {
                            let fiiterObject = JSON.parse(chipDataObject);
                            if (fiiterObject['filterdataobj_products_name'].length > 0) {
                                this.selectedProducts =
                                    JSON.parse(JSON.stringify(fiiterObject['filterdataobj_products_name']));
                            }
                        }
                        if (this.showApprovedProductsOnly) {
                            allProducts.map((x: any) => {
                                x.children = x.children.filter((x: { isShelfProduct: boolean }) => x.isShelfProduct);
                            })
                            this.productList = allProducts.filter((x: { hasShelfProduct: boolean }) => x.hasShelfProduct);
                        }
                    }
                }
                if (this.shelfPermissionIA != 'all') {
                    if (!chipDataObject) {
                        sessionStorage.setItem('allProducts', JSON.stringify(mainArray));
                        const productList = JSON.parse(JSON.stringify(mainArray));
                        if (this.showApprovedProductsOnly) {
                            this.productList = productList.filter((x: { hasShelfProduct: boolean }) => x.hasShelfProduct);
                        } else {
                            this.productList = productList;
                        }
                    } else {
                        chipDataObject = JSON.parse(chipDataObject);
                        if (chipDataObject['filterdataobj_products_name'].length == 0) {
                            sessionStorage.setItem('allProducts', JSON.stringify(mainArray));
                            const productList = JSON.parse(JSON.stringify(mainArray));
                            if (this.showApprovedProductsOnly) {
                                this.productList = productList.filter((x: { hasShelfProduct: boolean }) => x.hasShelfProduct);
                            } else {
                                this.productList = productList;
                            }
                        }
                    }
                }
            } else {
                if (chipDataObject) {
                    let fiiterObject = JSON.parse(chipDataObject);
                    if (fiiterObject['filterdataobj_products_name'].length > 0) {
                        this.selectedProducts =
                            JSON.parse(JSON.stringify(fiiterObject['filterdataobj_products_name']));
                    }
                }
            }
        }
        if (this.amRatingFlag != "amBests") {
            this.amBestRating = res.amBests;
            if (sidebarObj.amBestRating && sidebarObj.amBestRating.length == 0) {
                this.selectedAMBestrating = [];
            }
            else {
                this.selectedAMBestrating = res.amBests;
            }
        }
        if (this.riderFlag != 'riderFee') {
            this.riderFee = [];
            this.riderFeeData = [];
            this.riderFee.push(
                {
                    minRiderFee: res.riderFees.minRiderFee,
                    maxRiderFee: res.riderFees.maxRiderFee
                }
            )
            for (let i = 0; i < this.riderFee.length; i++) {

                for (this.riderFee[i].minRiderFee; this.riderFee[i].minRiderFee <= this.riderFee[i].maxRiderFee; this.riderFee[i].minRiderFee += 0.5) {
                    this.riderFeeData.push({ riderFee: this.riderFee[i].minRiderFee });
                }
                this.riderFeeData.push({ riderFee: this.riderFee[i].minRiderFee });
            }
        }
        if (sidebarObj.riderFee || sidebarObj.riderFee === 0) {
            this.selectedRiderFee = { riderFee: +(sidebarObj.riderFee).toString() };
        }
        if (this.surrFlag != "surrYrs") {
            this.surrenderYear = res.surrYrs;
            if (sidebarObj.surrYear.length == 0) {
                this.selectedSuryear = [];
            }
            else {
                this.selectedSuryear = res.surrYrs;
            }
        }

        if (sidebarObj.strategyFee && sidebarObj.strategyFee != 2) {
            this.selectedStrategyFee = { strategyFee: sidebarObj.strategyFee === 1 ? 'Yes' : 'No', value: +(sidebarObj.strategyFee) }
        }
        if (this.strategyFlag != 'strategyFees') {
            var strategyFeedata = res.strategyFees;
            this.strategyFee = [];
            for (let i = 0; i < strategyFeedata.length; i++) {
                this.strategyFee.push({ strategyFee: (strategyFeedata[i].strategyFee * 100) });
            }
        }

        // Check if 'chipDataObject' is null or undefined in sessionStorage
        if (!chipDataObject) {
            // Set all input properties for advance filter menu to blank array or null
            this.selectedGroups = [];
            this.selectedProducts = [];
            this.selectedAMBestrating = [];
            this.selectedSuryear = [];
            this.selectedRiderFee = null;
            this.selectedStrategyFee = null;
            this.filterdataobj_group_name = [];
            this.filterdataobj_products_name = [];
            this.SelectFilter_AMbest_name = [];
            this.filterdataobj_surrender_year_name = [];
            this.filterdataobj_riderfee_name = [];
            this.filterdataobj_strategyfee_name = [];
            this.filterdataobj_confiMulti_name = [];
            this.filteredSavedItem = 0;
            this.selectedCustomShelfName = 'Select';
        }else{
            this.isAdvanceFilterChanged = true;
        }
        if (this.filteredArray.length > 8) {
            this.ispagination = true
        } else {
            if (this.filteredArray.length == 0) {
                this.notFount = true;
            }
            this.ispagination = false
        }
    }

    expandCard(product: any) {
        // (document.getElementById(`collapse_${product.id}`) as HTMLElement).classList.toggle("show");
        // (document.getElementById(`product_${product.id}`) as HTMLElement).classList.toggle("card-collapsed");
        // if(!(document.getElementById(`collapse_${product.id}`) as HTMLElement).classList.contains('show')){
        //     // product.isCollapsed = false;
        // }else{
        //     this.currentProduct = product;
        //     this.showProductDialog = true;
        //     // product.isCollapsed = true;
        // }
        this.currentProduct = product;
        this.showProductDialog = true;
    }


    getBonusBasis(bonusPercentaseBaseId: number | null) {
        let bonusType = '';
        switch (bonusPercentaseBaseId) {
            case BonusTypeId.FixedAccountValue:
                bonusType = BonusType.FixedAccountValue;
                break;
            case BonusTypeId.ContractValue:
                bonusType = BonusType.ContractValue;
                break;
            case BonusTypeId.Others:
                bonusType = BonusType.Others;
                break;
            case BonusTypeId.PurchasePayments:
                bonusType = BonusType.PurchasePayments;
                break;
            case BonusTypeId.BenefitBase:
                bonusType = BonusType.BenefitBase;
                break;
            case BonusTypeId.InterestBonus:
                bonusType = BonusType.InterestBonus;
                break;
            case BonusTypeId.AccumulationValue:
                bonusType = BonusType.AccumulationValue;
                break;
            default:
                break;
        }
        return bonusType;
    }

    resetProductList(res: any) {
        this.filteredArray = [];
        this.gridData = [];
        this.pageNumber = 1;
        this.isLoader = false;
        this.showApprovedProductsOnly = res.showApprovedProducts;
        this.setProductList(res);
    }

    resetSideBarObject() {
        const sidebarObj1 = sessionStorage.getItem('sidebarObject');
        if (sidebarObj1) {
            let obj = JSON.parse(sidebarObj1);
            this.filterdataobj_group = obj.groupId != null ? obj.groupId : [];
            this.filterdataobj_products = obj.productId != null ? obj.productId : [];
            this.SelectFilter_AMbest = obj.amBestRating != null ? obj.amBestRating : [];
            this.filterdataobj_surrender_year = obj.surrYear != null ? obj.surrYear : [];
            this.filterdataobj_riderfee = obj.riderFee != null ? obj.groupId : null;
            this.filterdataobj_strategyfee = obj.strategyFee != null ? obj.groupId : null;
        }
    }

    showAdvanceFilterSpinner() {
        this.isLoader = true;
        this.filteredArray = [];
    }

    getExcelSheetData() {
        if (this.pageNumber == 1 && this.isFilterChanged) {
            this.showExportSpinner = true;
            this.isFilterChanged = false;
            this.getFilterSideBarInit(sessionStorage.getItem('sidebarObject'), true, true);
        } else {
            if (this.allProductRiders && this.allProductRiders.length > 0) {
                this.exportToExcel(this.allProductRiders);
            }else{
                this.showExportSpinner = true;
                this.getProductRiders(sessionStorage.getItem('sidebarObject'), true);
            }
        }
    }

    exportToExcel(productRiders: any = []) {
        this.showExportSpinner = false;
        this.allProductRiders = JSON.parse(JSON.stringify(productRiders));
        const filteredArray: any[] = [];
        if (productRiders.length > 0) {
            let counter = 0;
            for (let data of productRiders) {
                filteredArray.push(this.buildProductItem(data, counter, environment.domain));
                counter++;
            }
        }
        const assumptionsHeaders: string[] = [
            "Gender",
            "Owner Type",
            "Date of Birth",
            "Spousal Date of Birth",
            "State",
            "Income Type",
            "Amount Type",
            "Initial Benefit Base",
            "Deferral Period (yrs)",
            "Date Report Generated"
        ];
        let sidebarObj: any = sessionStorage.getItem('sidebarObject');
        if (sidebarObj) {
            sidebarObj = JSON.parse(sidebarObj);
        }
        const assumptionsData: string[][] = [
            [
                sidebarObj.gender == '' ? 'All' : sidebarObj.gender == 'M' ? 'Male' : 'Female',
                this.ownerType == 'joint' ? 'Joint' : 'Individual',
                this.ageSelectedDate,
                this.ownerType == 'joint' ? this.spageSelectedDate : '-',
                sidebarObj.stateCode == 'ALL' ? 'All' : sidebarObj.stateCode,
                sidebarObj.benefitBaseType,
                this.utilityFunctionService.toTitleCase(this.incCont),
                this.utilityFunctionService.formatCurrency(this.amountcheck),
                this.diffperiode,
                this.datePipe.transform(new Date(), "MM/dd/yyyy")
            ]
        ]

        const resultSetHeaders: string[] = [
            "Company Name",
            "Product Name",
            "Rider Name",
            "Income Type",
            "Amount",
            "Frequency",
            "Initial Benefit Base"
        ];
        const resultSetData: string[][] = [];
        for (let rider of filteredArray) {
            resultSetData.push([
                rider.companyName.trim(),
                rider.productName.trim(),
                rider.riderName.trim(),
                rider.benifitBaseType,
                this.utilityFunctionService.formatCurrency(rider.annualIncome),
                this.withdrawalFrequency,
                this.utilityFunctionService.formatCurrency(
                    rider.initialBenefitBase
                )
            ])
        }
        this.exportService.exportToExcel(assumptionsHeaders, assumptionsData, resultSetHeaders, resultSetData);
    }

    getProductRiders(sidebarObj: any, isExport: boolean = false) {
        this.benefitCalculatorService.postProductsDetails(sidebarObj).pipe(take(1)).subscribe((res: any) => {
            this.isLoader = false;
            if (isExport) {
                this.exportToExcel(res.productRiders);
            } else {
                this.setProductList(res);
            }
        }, (error) => {
            this.isLoader = false;
            this.messageService.add({ key: 'tc', severity: 'error', summary: 'Error', detail: 'Something went wrong, please try sometime' });
        });
    }

    setDOBs() {
        this.requestValues = {
            ageBand: this.topbarForm.get('age')?.value || 55,
            deferralYear: this.topbarForm.get('diffperiode')?.value,
            gender: this.topbarForm.get('gender')?.value || '',
            spageBand: this.topbarForm.get('pouseage')?.value || 55
        }
        this.ageSelectDate = new Date();
        this.ageSelectDate.setFullYear(this.ageSelectDate.getFullYear() - Number(this.requestValues.ageBand));
        this.ageSelectedDate = this.datePipe.transform(this.ageSelectDate, "MM/dd/yyyy");
        this.spageSelectDate = new Date();
        this.spageSelectDate.setFullYear(this.spageSelectDate.getFullYear() - Number(this.requestValues.spageBand));
        this.spageSelectedDate = this.datePipe.transform(this.spageSelectDate, "MM/dd/yyyy");
    }
    
    hideAcknowledgementDialog() {
        sessionStorage.setItem('showAcknowledgement', 'true');
        this.showAcknowledgementDialog = false;
    }

    resetAllFilter() {
        let sideBarObject: any = sessionStorage.getItem('initSidebarObject');
        if (sideBarObject) {
            sideBarObject = JSON.parse(sideBarObject);
            this.topbarForm.get('Contribution')?.patchValue(sideBarObject.amountType || 'contribution');
            this.topbarForm.get('amount')?.patchValue(sideBarObject.amount || 100000);
            this.topbarForm.get('periode')?.patchValue(sideBarObject.periode || 1);
            this.topbarForm.get('age')?.patchValue(sideBarObject.age || 55);
            this.topbarForm.get('pouseage')?.patchValue(sideBarObject.spage || 55);
            this.topbarForm.get('gender')?.patchValue(sideBarObject.gender == '' ? '' : sideBarObject.gender);
            this.topbarForm.get('diffperiode')?.patchValue(sideBarObject.deferralYear);
            this.topbarForm.get('ridertype')?.patchValue(sideBarObject.benefitBaseType);
            this.topbarForm.get('illinois')?.patchValue(sideBarObject.stateCode);
            this.ownerType = sideBarObject.joint == 'Yes' ? 'joint' : 'single';
            this.topbarForm.get('maritalstatus')?.patchValue(this.ownerType);
            sessionStorage.removeItem('chipDataObject');
            this.filteredSavedItem = 0;
            this.renderData(sessionStorage.getItem('initSidebarObject'), false);
        }
        // Emit resetAllFilterFlag to trigger clearAllFilter in advance-filter-menu component
        // First set to false to ensure we can detect the change to true
        this.advanceMenuClearAllFilterFlag = false;
        // Use timer to set it to true in the next tick, ensuring change detection picks it up
        timer(10).pipe(take(1)).subscribe(() => {
            this.advanceMenuClearAllFilterFlag = true;
            this.isFilterChanged = false;
        });
    }

    trackByIndex(index: number, _: any): number { return index; }
    trackByArrayIndex(_: number, item: any): any { return item?.arrayIndex; }

    ngOnDestroy() {
        this.destroy$.next();
        this.destroy$.complete();
        let basicFilterObj: any = this.getBasicFilterObj()
        this.withdrawalFrequency = basicFilterObj.periode == 1 ? 'Annually' : 'Monthly';
        sessionStorage.setItem("basicFilterObj", JSON.stringify(basicFilterObj));
        if (!this.benefitCalculatorService.resultSet) {
            const resultSet: any = {};
            this.benefitCalculatorService.resultSet = resultSet;
        }
        this.benefitCalculatorService.resultSet['productRiders'] = JSON.parse(JSON.stringify(this.filteredArray))
        this.benefitCalculatorService.resultSet.periodeam = this.periodeam;
        this.benefitCalculatorService.resultSet.showApprovedProductsOnly = this.showApprovedProductsOnly;
        this.benefitCalculatorService.resultSet.dataView = this.dataView;
        this.benefitCalculatorService.resultSet.totalCompare = this.totalCompare;
        this.benefitCalculatorService.resultSet.checked = this.checked;
        this.benefitCalculatorService.resultSet.totalMatches = this.totalMatches;
        if (this.compareData.length > 0) {
            this.benefitCalculatorService.resultSet.compareData = this.compareData;
            sessionStorage.setItem('compareData', JSON.stringify(this.compareData));
            if(!this.isClickedOnCompare){
                sessionStorage.removeItem('compareData');
            }
        } else {
            this.benefitCalculatorService.resultSet.compareData = [];
            sessionStorage.removeItem('compareData');
        }
    }

    resetCase() {
        let basicFilterObj: any = sessionStorage.getItem('initBasicFilterObj');
        if (basicFilterObj) {
            basicFilterObj = JSON.parse(basicFilterObj);
            this.topbarForm.get('Contribution')?.patchValue(basicFilterObj.amountType || 'contribution');
            this.topbarForm.get('amount')?.patchValue(basicFilterObj.amount || 100000);
            this.topbarForm.get('periode')?.patchValue(basicFilterObj.periode || 1);
            this.topbarForm.get('age')?.patchValue(basicFilterObj.age || 55);
            this.topbarForm.get('pouseage')?.patchValue(basicFilterObj.spage || 55);
            this.topbarForm.get('gender')?.patchValue(basicFilterObj.gender);
            this.topbarForm.get('diffperiode')?.patchValue(basicFilterObj.deferralYear);
            this.topbarForm.get('ridertype')?.patchValue(basicFilterObj.benefitBaseType);
            this.topbarForm.get('illinois')?.patchValue(basicFilterObj.stateCode);
            this.ownerType = basicFilterObj.joint == 'joint' ? 'joint' : 'single';
            this.topbarForm.get('maritalstatus')?.patchValue(this.ownerType);
            this.dataView = basicFilterObj.dataView ? basicFilterObj.dataView : 'grid';
        }

        let sideBarObject: any = sessionStorage.getItem('sidebarObject');
        if (sideBarObject) {
            sideBarObject = JSON.parse(sideBarObject);
            sideBarObject.gender = basicFilterObj.gender;
            sideBarObject.joint = basicFilterObj.joint == 'joint' ? 'Yes' : 'No';
            sideBarObject.age = basicFilterObj.age;
            sideBarObject.spage = basicFilterObj.spage;
            sideBarObject.stateCode = basicFilterObj.stateCode;
            sideBarObject.benefitBaseType = basicFilterObj.benefitBaseType;
            sideBarObject.amountType = basicFilterObj.amountType;
            sideBarObject.amount = basicFilterObj.amount;
            sideBarObject.periode = basicFilterObj.periode;
            sideBarObject.deferralYear = basicFilterObj.deferralYear;
            sessionStorage.setItem('sidebarObject', JSON.stringify(sideBarObject));
        }
        this.renderData(sessionStorage.getItem('sidebarObject'), false);
        // Emit resetAllFilterFlag to trigger clearAllFilter in advance-filter-menu component
        // First set to false to ensure we can detect the change to true
        this.advanceMenuClearAllFilterFlag = false;
        // Use timer to set it in the next tick, ensuring change detection picks it up
        timer(10).pipe(take(1)).subscribe(() => {
            this.advanceMenuClearAllFilterFlag = false;
            this.isFilterChanged = false;
        });
    }

    setDataView(dataView: string) {
        if (this.dataView != dataView) {
            let basicFilterObj: any = sessionStorage.getItem('basicFilterObj');
            if (basicFilterObj) {
                basicFilterObj = JSON.parse(basicFilterObj);
                basicFilterObj.dataView = dataView;
                sessionStorage.setItem('basicFilterObj', JSON.stringify(basicFilterObj));
            }
            this.dataView = dataView;
            this.benefitCalculatorService.resultSet.dataView = dataView;
            this.isFilterChanged = true;
        }
    }

    getInitialBenefitBase(data: any){
        let contribution: number = this.topbarForm.get('Contribution')?.value === 'contribution' ? (this.topbarForm.get('amount')?.value || 100000) : this.getAnnualIncome(data);
        contribution = Number(contribution);
        if (data.isGmwbBonusBenefitBase) {
            contribution = (contribution) + (((contribution) * data.bonusPercentage) / 100);
        }
        if (data.isBonusBenefitBase) {
            contribution = ((contribution) + (((contribution) * data.premiumBonus) / 100));
        }
        return contribution;
    }

    private buildProductItem(data: any, arrayIndex: number, logoPrefix: string = ''): any {
        const basicFilterObj: any = sessionStorage.getItem('basicFilterObj');
        let amountType = 'contribution';
        if (basicFilterObj) {
            amountType = JSON.parse(basicFilterObj).amountType;
        }
        const isContribution = amountType === 'contribution';
        const rollUpdata = this.calculateRollUp(data);
        return {
            arrayIndex,
            logo1: data.logo1 != null ? logoPrefix + data.logo1 : this.altImg,
            logo2: data.logo2 != null ? logoPrefix + data.logo2 : this.altImg,
            gmwbId: data.gmwbId,
            productid: data.productid,
            productName: data.productName,
            companyid: data.companyid,
            companyName: data.companyName,
            riderName: data.riderName,
            minAge: data.minAge,
            maxAge: data.maxAge,
            riderFee: data.riderFee,
            rollupPer: data.rollupPer,
            withdrawalPer: data.withdrawalPer,
            riderFeeJoint: data.riderFeeJoint,
            rollupPerJoint: data.rollupPerJoint,
            withdrawalPerJoint: data.withdrawalPerJoint,
            maxRollupYears: data.rollupYears,
            rollupYears: data.rollupYears,
            isCaseAOrC: data.isCaseAOrC,
            ageBand1: data.ageBand1,
            ageBand2: data.ageBand2,
            purchasePayBonus: data.purchasePayBonus,
            internalName: data.internalName,
            bonusPercentage: data.bonusPercentage,
            bonusName: data.bonusName,
            factorSingle: data.factorSingle,
            factorJoint: data.factorJoint,
            premiumBonus: data.premiumBonus,
            id: data.id,
            otherVariable: data.otherVariable,
            bbBonus: data.bbBonus,
            groupId: data.groupId,
            groupName: data.groupName,
            bestid: data.bestid,
            surryr: data.surryr,
            strategyFee: data.strategyFee,
            gender: data.gender,
            bonusCaseId: data.bonusCaseId,
            bonusCaseName: data.bonusCaseName,
            availStateException: data.availStateException ? data.availStateException : "",
            exceptions: data.exceptions,
            rollupIsSimpleComp: data.rollupIsSimpleComp,
            riderFeedata: data.riderFee,
            chargeBasisName: data.chargeBasisName,
            highAnnivValStepup: data.highAnnivValStepup,
            annualIncome: this.getAnnualIncome(data),
            IncomePeriod: this.topbarForm.get('Contribution')?.value == 'contribution' ? (this.topbarForm.get('periode')?.value ? 'Est. Annual Inc.' : 'Est. Monthly Inc.') : 'Est. Initial Contrib.',
            rollUp: this.topbarForm.get('pouseage')?.value && this.topbarForm.get('pouseage')?.value != 0 ? data.rollupPerJoint : data.rollupPer,
            withdrawal: this.ownerType.toLowerCase() === 'joint' ? data.withdrawalPerJoint : data.withdrawalPer,
            gmwbAvailStateExceptions: data.gmwbAvailStateExceptions,
            isChecked: false,
            benifitBaseType: data.benifitBaseType,
            isCollapsed: false,
            waitingTerm: data.waitingTerm,
            waitingPeriod: data.waitingPeriod,
            rollUpdata,
            marketingName: data.marketingName,
            chargeFreqDeductedWhen: data.chargeFreqDeductedWhen,
            bonusPercentageBasis: data.bonusPercentageBasis,
            isShelfProduct: this.approvedProductIds.indexOf(data.productid) > -1,
            isGmwbBonusBenefitBase: data.isGmwbBonusBenefitBase,
            isBonusBenefitBase: data.isBonusBenefitBase,
            isGmwbBonusAccountValue: data.isGmwbBonusAccountValue,
            isBonusAccountValue: data.isBonusAccountValue,
            initialBenefitBase:this.getAnnualIncome(data, true),
        };
    }

    private saveChipData(): void {
        const chipDataObject = {
            filterdataobj_group_name: this.filterdataobj_group_name,
            filterdataobj_products_name: this.filterdataobj_products_name,
            SelectFilter_AMbest_name: this.SelectFilter_AMbest_name,
            filterdataobj_surrender_year_name: this.filterdataobj_surrender_year_name,
            filterdataobj_riderfee_name: this.filterdataobj_riderfee_name,
            filterdataobj_strategyfee_name: this.filterdataobj_strategyfee_name
        };
        sessionStorage.setItem("chipDataObject", JSON.stringify(chipDataObject));
    }

    private getBasicFilterObj(): any {
        return {
            spage: this.topbarForm.get('pouseage')?.value,
            amountType: this.topbarForm.get('Contribution')?.value,
            amount: this.topbarForm.get('amount')?.value,
            periode: this.topbarForm.get('periode')?.value,
            gender: this.topbarForm.get('gender')?.value,
            deferralYear: this.topbarForm.get('diffperiode')?.value,
            benefitBaseType: this.topbarForm.get('ridertype')?.value,
            stateCode: this.topbarForm.get('illinois')?.value,
            joint: this.ownerType,
            age: this.topbarForm.get('age')?.value,
            dataView: this.dataView,
        };
    }

    private initMenuItems(): void {
        this.useritems = [
            { label: 'Account Settings', icon: 'pi pi-user-edit', command: () => { this.router.navigate(['/profilesetting']); } },
            { label: 'Default Setting', icon: 'pi pi-cog', command: () => { this.router.navigate(['/adminsystem']); } },
            { label: 'My Saved Searches', icon: 'pi pi-save', command: () => { this.router.navigate(['/savedsearch']); } },
            { label: 'My Custom Shelfs', icon: 'pi pi-book', command: () => { this.router.navigate(['/customshelf']); } },
            { label: 'Logout', icon: 'pi pi-sign-out', command: () => { this.onLogout(); } }
        ];
        this.categories = [
            { name: "Withdrawal Amount" },
            { name: "Company Name" },
            { name: "Product Name" }
        ];
        if (this.categories.length > 0) {
            this.selectedSortBymodel = this.categories[0];
        }
    }

}